import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
  Card,
  Table,
  Form,
  Alert,
} from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { timeToDateFill } from "../../herramientas/DateFormat";
import Select from "react-select";
import {
  NotificationManager,
} from "react-notifications";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import ModalLay from "../../components/ModalLay/ModalLay";
import OperadoresForm from "../../Catalogos/Operadores/OperadoresForm";
import OperadoresFormSimple from "../../Catalogos/Operadores/OperadoresFormSimple";
import TractosForm from "../../Catalogos/Tractos/TractosForm";
import RemolquesForm from "../../Catalogos/Remolques/RemolquesForm";
import "./DatosMovimientoGpsForm.css";
const estilo = {
  color: "red",
  size: 100,
  "border-width": "5px",
  padding: "0px",
  "margin-top": "1.0em",
};
let gpsAgregadoOld= [];
let gpsAgregadosFullOld= [];
let guardando= false;
const steps = ["Guardando unidad, remolque, operador", "Guardando gps's", "Comprobando unidad, remolque, operador", "Comprobando gps's"];
const DatosMovimientoGpsForm =({ movimientos, movimiento, idMovimiento, usuario, plataformaid, refetch})=> {
  const [saveProgress, setSaveProgress]= useState({activeStep: null, isStepFailed: null, stepFailedMessage: ""});
  const [saveProgressFull, setSaveProgressFull]= useState({activeStep: null, isStepFailed: null, stepFailedMessage: ""});
  const [datosGps, setDatosGps]= useState({});
  const [disabledButon, setDisabledButon]= useState(false);
  const [esFull, setEsFull]= useState(false);
  //idRemolqueFull: { value: 0, label: "Seleccione una Opción" },
  const [movimientosPatios, setMovimientosPatios]= useState(
    {
      idMovimiento: null,
      economicor: "",//*
      economicot: "",//*
      idRemolque: { idRemolque: 0 },
      operadorNombre: "",
      operadorContacto: "",
      operadorLicencia: "",
      tractorModelo: "",
      tractorMarca: "",
      tractorColor: "",
      enProtocolo: true,
      movimientoLocal: false,
      tractorPlaca: "",
      esFull: "",
      remolquePlaca: "",//*
      colocacionFecha: null,
      observaciones: "",
      idLocalidad: null,
      idUsuario: usuario,
    }
  );
  //MOVIMIENTO PRINCIPAL
  const [movimientoPrimario, setMovimientoPrimario]= useState({ });//po1
  const [movimientoFull, setMovimientoFull]= useState({ });//po1
  const [gpsAgregado, setGpsAgregado]= useState([]);
  const [gpsList, setGpsList]= useState([]);
  const [gps, setGps]= useState({ value: 0, label: "Seleccione un GPS", data: null });//idGps
  const [tipoColocacion, setTipoColocacion]= useState({ value: 0, label: "Seleccione una opción", data_: null });//tipoGps
  const [remolques, setRemolques]= useState([]);
  const [idRemolque, setIdRemolque]= useState({ value: 0, label: "Seleccione una Opción" });//idRemolque
  const [idRemolqueFull, setIdRemolqueFull]= useState({ value: 0, label: "Seleccione una Opción" });//idRemolqueFull
  const [controlador, setControlador]= useState({
    value: usuario.id,
    label:
      usuario.nombre +
      " " +
      usuario.aPaterno +
      " " +
      usuario.aMaterno,
      data: usuario
  });//usuario


  //MOVIMIENTO SECUNDARIO
  const [movimientoSecundario, setMovimientoSecundario]= useState({ value: 0, label: "Seleccione un Movimiento", data: null});//po2, idMovFull
  const [gpsAgregadosFull, setGpsAgregadosFull]= useState([]);//gpsAgregadosFull
  const [gpsFull, setGpsFull]= useState({ value: 0, label: "Seleccione un GPS", data: null });//idGpsFull
  const [tipoColocacionFull, setTipoColocacionFull]= useState({ value: 0, label: "Seleccione una opción", data_: null });//tipoGpsFull


  const [movimientosSinGps, setMovimientosSinGps]= useState([]);//movimientosSinGps
  const [gpsGateEtiquetas, setGpsGateEtiquetas]= useState([]);//gpsGateEtiquetas null
  const [updateMSG, setUpdateMSG]= useState(false);//updateMSG
  const [gpstipocolocaciones, setGpstipocolocaciones]= useState([]);//gpstipocolocacion
  const [usuarios, setUsuarios]= useState([
    { value: 0, label: "Seleccione una opción" },
    {
      value: usuario.id,
      label:
        usuario.nombre +
        " " +
        usuario.aPaterno +
        " " +
        usuario.aMaterno,
      data: usuario
    },
  ]);//usuarios
  const [movimientosPatiosFull, setMovimientosPatiosFull]= useState(
    {
      idMovimiento: null,//verificar
      economicor: "",//*
      economicot: "",
      idRemolque: { idRemolque: 0 },
      operadorNombre: "",
      operadorContacto: "",
      operadorLicencia: "",
      tractorModelo: "",
      tractorMarca: "",
      tractorColor: "",
      enProtocolo: true,
      movimientoLocal: false,
      tractorPlaca: "",
      esFull: "",
      remolquePlaca: "",//*
      colocacionFecha: null,
      observaciones: "",//*
      idLocalidad: null,
      idUsuario: usuario,
    }
  );
  const [images, setImages] = useState({});
  //Session Storage
  const sessionUser = JSON.parse(sessionStorage.getItem("usuario")) || {};
  const idsPermitidos = [16051,107199, 139406, 144719, 99478, 99608, 48630, 121222, 1090, 120859, 99215]; // TODO: Ajustar IDs permitidos falta imagana
  const puedeEliminarGps = idsPermitidos.includes(sessionUser.id);

  // ═══ ESTADOS PARA DROPDOWNS DE CATÁLOGOS ═══
  const [idTransportista, setIdTransportista] = useState(null);
  const [idsTransportistasHermanos, setIdsTransportistasHermanos] = useState([]); // Todos los IDs de transportistas hermanos (incluye el principal)
  const [catalogosListos, setCatalogosListos] = useState(false); // true cuando la carga de catálogos (con hermanos) terminó
  const [operadoresOpciones, setOperadoresOpciones] = useState([]);
  const [operadorSeleccionado, setOperadorSeleccionado] = useState(null);
  const [operadorActualObj, setOperadorActualObj] = useState(null);
  const [tractosOpciones, setTractosOpciones] = useState([]);
  const [tractoSeleccionado, setTractoSeleccionado] = useState(null);
  const [tractoActualObj, setTractoActualObj] = useState(null);
  const [remolquesOpciones, setRemolquesOpciones] = useState([]);
  const [remolqueSeleccionado, setRemolqueSeleccionado] = useState(null);
  const [remolqueActualObj, setRemolqueActualObj] = useState(null);
  const [remolqueFullSeleccionado, setRemolqueFullSeleccionado] = useState(null);
  const [remolqueFullActualObj, setRemolqueFullActualObj] = useState(null);
  const [unidadesMarcasMap, setUnidadesMarcasMap] = useState({});

   // NUEVA FUNCIÓN: Obtener estatus GPS según movimientoLocal
   const obtenerEstatusGps = (movimientoLocal) => {
    return movimientoLocal ? "1,2" : "1";
  };

  // NUEVA FUNCIÓN: Cargar GPS según movimientoLocal
  const cargarGpsSegunMovimientoLocal = (esMovimientoLocal, filtroNombre = "") => {
    const estatusGps = obtenerEstatusGps(esMovimientoLocal);
    // Construir endpoint con filtro opcional
    let endpoint = `gps/idestatus/${estatusGps}`;
    if (filtroNombre && filtroNombre.trim().length > 0) {
      endpoint += `?nombre=${encodeURIComponent(filtroNombre.trim())}`;
    } 
    //console.log(`Cargando GPS con estatus ${estatusGps} para movimientoLocal: ${esMovimientoLocal}${filtroNombre ? ` con filtro: ${filtroNombre}` : ''}`);
    //console.log(`Endpoint: ${endpoint}`);
    getfuntion("get", [], "", endpoint, "gpsDisponible");
  };

  // NUEVA FUNCIÓN: Buscar GPS por nombre (NUEVA)
  const buscarGpsPorNombre = (nombreFiltro) => {
    if (!nombreFiltro || nombreFiltro.trim().length < 2) {
      // Si no hay filtro o es muy corto, cargar todos los GPS según movimientoLocal
      cargarGpsSegunMovimientoLocal(movimientosPatios.movimientoLocal);
      return;
    }    
    // Cargar GPS con filtro de nombre
    cargarGpsSegunMovimientoLocal(movimientosPatios.movimientoLocal, nombreFiltro);
  };

  // NUEVA FUNCIÓN: Reset selecciones GPS
  const resetearSeleccionesGps = () => {
    setGps({ value: 0, label: "Seleccione un GPS", data: null });
    setGpsFull({ value: 0, label: "Seleccione un GPS", data: null });
    setTipoColocacion({ value: 0, label: "Seleccione una opción", data_: null });
    setTipoColocacionFull({ value: 0, label: "Seleccione una opción", data_: null });
    setDatosGps({});
  };

  useEffect(()=>{
    gpsAgregadoOld= [];
    gpsAgregadosFullOld= [];
    guardando= false;
    let movSinGpsTem = [];
    for( let m of movimientos ){
      if (idMovimiento !== m.idMovimiento
        && movimiento.movimientoTipo === m.movimientoTipo
        && movimiento.corredor === m.corredor
        && (!movimiento.esFull || !movimiento.esFull.length)
        && movSinGpsTem.filter(msg=> Number(msg.value) === m.idMovimiento).length === 0
        ) {
        movSinGpsTem.push({
          value: m.idMovimiento,
          label: m.idMovimiento + " - " + m.po + " - " + m.contenedor,
          data: m,
        });
      }
    }

    setMovimientosSinGps(movSinGpsTem);
    // primario obtener movimiento
    getfuntion( "get", [], "", "navieraMovimientos/" + movimiento.idMovimiento, "movimiento" );
    /**
     * Catalogos
     */
    getfuntion(
      "get",
      [],
      "",
      "gpsGateEtiquetas/"+plataformaid+"/PLATAFORMA/" + plataformaid,
      "gpsGateEtiquetas"
    );
    getfuntion("get", [], "", "remolquesTipo", "remolquesTipo"); //Gps gpstipocolocacion
    getfuntion("get", [], "", "gpsTipoColocacion", "gpstipocolocacion"); //Gps gpstipocolocacion
    // Cargar marcas de unidades para lookup
    Crud_Catalogos("unidadesMarcasActivas", "", "get", "", [], "", "", "", []).then((marcas) => {
      if (marcas && Array.isArray(marcas)) {
        const map = {};
        marcas.forEach(m => { map[m.id] = m.nombre; });
        setUnidadesMarcasMap(map);
      }
    }).catch(() => {});
     // MODIFICADO: Cargar GPS según movimientoLocal inicial
    cargarGpsSegunMovimientoLocal(movimientosPatios.movimientoLocal);
     // full obtener movmiento, patio, gps
  },[]);  

  useEffect(()=>{
    if (movimientoPrimario.id) {
      if (!movimientoPrimario.idPlataforma.zonaHoraria)
        movimientoPrimario.idPlataforma.zonaHoraria = "";
      // primario obtener patio
      if(!movimientosPatios.id){
        getfuntion("get", [], "", "movimientosPatio/idMovimiento/" + idMovimiento, "movimientosPatio" );
      }
      if(!guardando){
        cargaGps(movimientoPrimario);
      }
    }
  },[movimientoPrimario]);

  // ═══ CARGA DE CATÁLOGOS (operadores, tractos, remolques) ═══
  useEffect(() => {
    if (movimientoPrimario.id && movimientoPrimario.idTransportista?.id) {
      const idTransp = movimientoPrimario.idTransportista.id;
      setIdTransportista(idTransp);
      setCatalogosListos(false); // Marcar que se está cargando
      // Obtener transportistas hermanos:
      // 1. Obtener usuarios vinculados al transportista del movimiento
      // 2. Para cada usuario, obtener todos sus transportistas
      // 3. Con todos esos IDs cargar los catálogos
      const plataformaSession = JSON.parse(sessionStorage.getItem("plataforma"));
      const idPlataforma = plataformaSession?.id || movimientoPrimario.idPlataforma?.id;
      
      const cargarCatalogosConIds = (idsTransportistas) => {
        // Guardar IDs hermanos para validación del botón vincular
        setIdsTransportistasHermanos(idsTransportistas);
        // Cargar catálogos y marcar como listos cuando TODOS terminen
        Promise.all([
          cargarOperadoresPorTransportistas(idsTransportistas),
          cargarTractosPorTransportistas(idsTransportistas),
          cargarRemolquesPorTransportistas(idsTransportistas),
        ]).then(() => {
          setCatalogosListos(true);
        }).catch(() => {
          setCatalogosListos(true);
        });
      };

      Crud_Catalogos("usuarios_transportistas/transportista/" + idTransp, "", "get", "", [], "", "", "", [])
        .then((usuariosDelTransportista) => {
          if (usuariosDelTransportista && Array.isArray(usuariosDelTransportista) && usuariosDelTransportista.length > 0) {
            // Obtener IDs únicos de usuarios vinculados a este transportista
            // idUsuario puede ser un número directo o un objeto {id: X}
            const idsUsuarios = [...new Set(
              usuariosDelTransportista.map(h => {
                if (typeof h.idUsuario === 'number') return h.idUsuario;
                if (h.idUsuario?.id) return h.idUsuario.id;
                return null;
              }).filter(Boolean)
            )];
            
            if (idsUsuarios.length > 0 && idPlataforma) {
              // Para cada usuario, obtener todos sus transportistas en esta plataforma
              const promesasUsuarios = idsUsuarios.map(idUsr =>
                Crud_Catalogos("usuarios_transportistas/usuario/" + idUsr + "/plataforma/" + idPlataforma, "", "get", "", [], "", "", "", [])
                  .then((relaciones) => (relaciones && Array.isArray(relaciones)) ? relaciones : [])
                  .catch(() => [])
              );
              
              Promise.all(promesasUsuarios).then((resultados) => {
                const todasRelaciones = resultados.flat();
                const idsTransportistas = [...new Set(todasRelaciones.map(r => r.idTransportista).filter(Boolean))];
                
                if (idsTransportistas.length > 0) {
                  // Asegurar que el ID principal siempre esté incluido
                  if (!idsTransportistas.includes(idTransp)) {
                    idsTransportistas.push(idTransp);
                  }
                  cargarCatalogosConIds(idsTransportistas);
                } else {
                  // Fallback: cargar solo del transportista actual
                  cargarCatalogosConIds([idTransp]);
                }
              });
            } else {
              // Fallback: cargar solo del transportista actual
              cargarCatalogosConIds([idTransp]);
            }
          } else {
            // Fallback: cargar solo del transportista actual
            cargarCatalogosConIds([idTransp]);
          }
        })
        .catch((err) => {
          console.error("Error obteniendo transportistas hermanos:", err);
          // Fallback: cargar solo del transportista actual
          setIdsTransportistasHermanos([idTransp]);
          Promise.all([
            cargarOperadoresPorTransportistas([idTransp]),
            cargarTractosPorTransportistas([idTransp]),
            cargarRemolquesPorTransportistas([idTransp]),
          ]).then(() => {
            setCatalogosListos(true);
          }).catch(() => {
            setCatalogosListos(true);
          });
        });
    }
  }, [movimientoPrimario]);

  const cargarOperadores = (idTransp) => {
    cargarOperadoresPorTransportistas([idTransp]);
  };

  const cargarOperadoresPorTransportistas = (idsTransportistas) => {
    const promesas = idsTransportistas.map(idTransp =>
      Crud_Catalogos("operadores/transportista/" + idTransp, "", "get", "", [], "", "", "", [])
        .then((returnVal) => (returnVal && Array.isArray(returnVal)) ? returnVal : [])
        .catch(() => [])
    );
    return Promise.all(promesas).then((resultados) => {
      const todosOperadores = resultados.flat();
      // Eliminar duplicados por id
      const unicos = todosOperadores.filter((op, index, self) =>
        index === self.findIndex(o => o.id === op.id)
      );
      const opciones = unicos.map(op => ({
        value: op.id,
        label: op.nombreCompleto || `${op.nombre} ${op.paterno || ""} ${op.materno || ""}`.trim(),
        data: op
      }));
      setOperadoresOpciones(opciones);
    });
  };

  const cargarTractos = (idTransp) => {
    cargarTractosPorTransportistas([idTransp]);
  };

  const cargarTractosPorTransportistas = (idsTransportistas) => {
    const promesas = idsTransportistas.map(idTransp =>
      Crud_Catalogos("unidadTerNav/idTransportista/" + idTransp, "", "get", "", [], "", "", "", [])
        .then((returnVal) => (returnVal && Array.isArray(returnVal)) ? returnVal : [])
        .catch(() => [])
    );
    return Promise.all(promesas).then((resultados) => {
      const todosTractos = resultados.flat();
      // Eliminar duplicados por id
      const unicos = todosTractos.filter((tr, index, self) =>
        index === self.findIndex(t => t.id === tr.id)
      );
      const opciones = unicos.map(tr => ({
        value: tr.id,
        label: tr.placa || "",
        data: tr
      }));
      setTractosOpciones(opciones);
    });
  };

  const cargarRemolques = (idTransp) => {
    cargarRemolquesPorTransportistas([idTransp]);
  };

  const cargarRemolquesPorTransportistas = (idsTransportistas) => {
    const promesas = idsTransportistas.map(idTransp =>
      Crud_Catalogos("remolques_transportistas/id_transportista/" + idTransp, "", "get", "", [], "", "", "", [])
        .then((relaciones) => (relaciones && Array.isArray(relaciones)) ? relaciones : [])
        .catch(() => [])
    );
    return Promise.all(promesas).then((resultadosRelaciones) => {
      const todasRelaciones = resultadosRelaciones.flat();
      const idsRemolques = todasRelaciones.filter(r => r.estatus !== false).map(r => r.idRemolque);
      // Eliminar IDs duplicados
      const idsUnicos = [...new Set(idsRemolques)];
      if (idsUnicos.length > 0) {
        return Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
          .then((todosRemolques) => {
            if (todosRemolques && Array.isArray(todosRemolques)) {
              const remolquesFiltrados = todosRemolques.filter(r => idsUnicos.includes(r.idRemolque));
              const opciones = remolquesFiltrados.map(rem => ({
                value: rem.idRemolque,
                label: rem.placa || "",
                data: rem
              }));
              setRemolquesOpciones(opciones);
            }
          });
      }
    });
  };

  // Pre-seleccionar items cuando se carga movimientosPatios con datos existentes
  useEffect(() => {
    if (movimientosPatios.id && operadoresOpciones.length > 0) {
      // Buscar operador por nombre
      if (movimientosPatios.operadorNombre) {
        const opMatch = operadoresOpciones.find(op =>
          op.label?.toUpperCase().trim() === movimientosPatios.operadorNombre?.toUpperCase().trim()
        );
        if (opMatch) {
          setOperadorSeleccionado(opMatch);
          setOperadorActualObj(opMatch.data);
        }
      }
    }
  }, [movimientosPatios.id, operadoresOpciones]);

  // Si hay datos en movimientosPatios pero no hay match en catálogo, crear opción temporal para mostrar el valor
  // SOLO cuando catalogosListos=true (evitar mostrar "Vincular" mientras aún cargan hermanos)
  useEffect(() => {
    if (movimientosPatios.id && movimientosPatios.operadorNombre && !operadorSeleccionado && catalogosListos) {
      setOperadorSeleccionado({ value: -1, label: movimientosPatios.operadorNombre, data: null });
    }
  }, [movimientosPatios.id, movimientosPatios.operadorNombre, operadoresOpciones, catalogosListos]);

  useEffect(() => {
    if (movimientosPatios.id && tractosOpciones.length > 0) {
      // Buscar tracto por placa
      if (movimientosPatios.tractorPlaca) {
        const trMatch = tractosOpciones.find(tr =>
          tr.data?.placa?.toUpperCase().trim() === movimientosPatios.tractorPlaca?.toUpperCase().trim()
        );
        if (trMatch) {
          setTractoSeleccionado(trMatch);
          setTractoActualObj(trMatch.data);
        }
      }
    }
  }, [movimientosPatios.id, tractosOpciones]);

  useEffect(() => {
    if (movimientosPatios.id && movimientosPatios.tractorPlaca && !tractoSeleccionado && catalogosListos) {
      setTractoSeleccionado({ value: -1, label: movimientosPatios.tractorPlaca, data: null });
    }
  }, [movimientosPatios.id, movimientosPatios.tractorPlaca, tractosOpciones, catalogosListos]);

  useEffect(() => {
    if (movimientosPatios.id && remolquesOpciones.length > 0) {
      // Buscar remolque por placa
      if (movimientosPatios.remolquePlaca) {
        const remMatch = remolquesOpciones.find(rem =>
          rem.data?.placa?.toUpperCase().trim() === movimientosPatios.remolquePlaca?.toUpperCase().trim()
        );
        if (remMatch) {
          setRemolqueSeleccionado(remMatch);
          setRemolqueActualObj(remMatch.data);
          // Actualizar tipo de plataforma con el remolquesTipos actual del catálogo
          if (remMatch.data?.remolquesTipos) {
            setIdRemolque({ value: remMatch.data.remolquesTipos.idRemolque, label: remMatch.data.remolquesTipos.nombre, data: remMatch.data.remolquesTipos });
            setMovimientosPatios(prev => ({
              ...prev,
              idRemolque: remMatch.data.remolquesTipos,
            }));
          }
        }
      }
    }
  }, [movimientosPatios.id, remolquesOpciones]);

  useEffect(() => {
    if (movimientosPatios.id && movimientosPatios.remolquePlaca && !remolqueSeleccionado && catalogosListos) {
      setRemolqueSeleccionado({ value: -1, label: movimientosPatios.remolquePlaca, data: null });
    }
  }, [movimientosPatios.id, movimientosPatios.remolquePlaca, remolquesOpciones, catalogosListos]);

  useEffect(() => {
    if (movimientosPatiosFull.id && remolquesOpciones.length > 0) {
      if (movimientosPatiosFull.remolquePlaca) {
        const remFullMatch = remolquesOpciones.find(rem =>
          rem.data?.placa?.toUpperCase().trim() === movimientosPatiosFull.remolquePlaca?.toUpperCase().trim()
        );
        if (remFullMatch) {
          setRemolqueFullSeleccionado(remFullMatch);
          setRemolqueFullActualObj(remFullMatch.data);
          // Actualizar tipo de plataforma full con el remolquesTipos actual del catálogo
          if (remFullMatch.data?.remolquesTipos) {
            setIdRemolqueFull({ value: remFullMatch.data.remolquesTipos.idRemolque, label: remFullMatch.data.remolquesTipos.nombre, data: remFullMatch.data.remolquesTipos });
            setMovimientosPatiosFull(prev => ({
              ...prev,
              idRemolque: remFullMatch.data.remolquesTipos,
            }));
          }
        }
      }
    }
  }, [movimientosPatiosFull.id, remolquesOpciones]);

  useEffect(() => {
    if (movimientosPatiosFull.id && movimientosPatiosFull.remolquePlaca && !remolqueFullSeleccionado && catalogosListos) {
      setRemolqueFullSeleccionado({ value: -1, label: movimientosPatiosFull.remolquePlaca, data: null });
    }
  }, [movimientosPatiosFull.id, movimientosPatiosFull.remolquePlaca, remolquesOpciones, catalogosListos]);

  // ═══ HANDLERS para selección de catálogos ═══
  const handleSeleccionarOperador = (selectedOption) => {
    if (selectedOption) {
      setOperadorSeleccionado(selectedOption);
      setOperadorActualObj(selectedOption.data);
      // Solo actualizar movimientosPatios si data existe (no es opción temporal)
      if (selectedOption.data) {
        const op = selectedOption.data;
        setMovimientosPatios(prev => ({
          ...prev,
          operadorNombre: op.nombreCompleto || `${op.nombre} ${op.paterno || ""} ${op.materno || ""}`.trim(),
          operadorContacto: op.medioComunicacion || "",
          operadorLicencia: op.licenciaTipo || "",
        }));
      }
    } else {
      setOperadorSeleccionado(null);
      setOperadorActualObj(null);
      setMovimientosPatios(prev => ({
        ...prev,
        operadorNombre: "",
        operadorContacto: "",
        operadorLicencia: "",
      }));
    }
  };

  const handleSeleccionarTracto = (selectedOption) => {
    if (selectedOption) {
      setTractoSeleccionado(selectedOption);
      setTractoActualObj(selectedOption.data);
      // Solo actualizar movimientosPatios si data existe (no es opción temporal)
      if (selectedOption.data) {
        const tr = selectedOption.data;
        // Obtener nombre de marca: primero del objeto expandido, luego por lookup en mapa
        let marcaNombre = "";
        if (tr.idUnidadMarca?.nombre) {
          marcaNombre = tr.idUnidadMarca.nombre;
        } else if (tr.idUnidadMarca?.id && unidadesMarcasMap[tr.idUnidadMarca.id]) {
          marcaNombre = unidadesMarcasMap[tr.idUnidadMarca.id];
        }
        setMovimientosPatios(prev => ({
          ...prev,
          tractorModelo: tr.modelo || "",
          tractorMarca: marcaNombre,
          tractorColor: tr.color || "",
          tractorPlaca: tr.placa || "",
          economicot: tr.economico || "",
        }));
      }
    } else {
      setTractoSeleccionado(null);
      setTractoActualObj(null);
      setMovimientosPatios(prev => ({
        ...prev,
        tractorModelo: "",
        tractorMarca: "",
        tractorColor: "",
        tractorPlaca: "",
        economicot: "",
      }));
    }
  };

  const handleSeleccionarRemolque = (selectedOption) => {
    if (selectedOption) {
      setRemolqueSeleccionado(selectedOption);
      setRemolqueActualObj(selectedOption.data);
      // Solo actualizar movimientosPatios si data existe (no es opción temporal)
      if (selectedOption.data) {
        const rem = selectedOption.data;
        // Auto-rellenar tipo de plataforma desde el remolque
        if (rem.remolquesTipos) {
          setIdRemolque({ value: rem.remolquesTipos.idRemolque, label: rem.remolquesTipos.nombre, data: rem.remolquesTipos });
          setMovimientosPatios(prev => ({
            ...prev,
            remolquePlaca: rem.placa || "",
            economicor: rem.economico || "",
            idRemolque: rem.remolquesTipos,
          }));
        } else {
          setMovimientosPatios(prev => ({
            ...prev,
            remolquePlaca: rem.placa || "",
            economicor: rem.economico || "",
          }));
        }
        // Verificar si el remolque seleccionado tiene un GPS fijo vinculado (por placa)
        // para pre-llenar NOMBRE GPS / TIPO GPS y auto-agregarlo a la lista.
        if (rem.placa) {
          getfuntion("get", [], "", "remolquesGpsFijos/placa/" + encodeURIComponent(rem.placa) + "/activo", "gpsFijoVinculado");
        }
      }
    } else {
      setRemolqueSeleccionado(null);
      setRemolqueActualObj(null);
      setIdRemolque({ value: 0, label: "Seleccione una Opción" });
      setMovimientosPatios(prev => ({
        ...prev,
        remolquePlaca: "",
        economicor: "",
        idRemolque: { idRemolque: 0 },
      }));
    }
  };

  const handleSeleccionarRemolqueFull = (selectedOption) => {
    if (selectedOption) {
      setRemolqueFullSeleccionado(selectedOption);
      setRemolqueFullActualObj(selectedOption.data);
      // Solo actualizar movimientosPatiosFull si data existe (no es opción temporal)
      if (selectedOption.data) {
        const rem = selectedOption.data;
        // Auto-rellenar tipo de plataforma desde el remolque full
        if (rem.remolquesTipos) {
          setIdRemolqueFull({ value: rem.remolquesTipos.idRemolque, label: rem.remolquesTipos.nombre, data: rem.remolquesTipos });
          setMovimientosPatiosFull(prev => ({
            ...prev,
            remolquePlaca: rem.placa || "",
            economicor: rem.economico || "",
            idRemolque: rem.remolquesTipos,
          }));
        } else {
          setMovimientosPatiosFull(prev => ({
            ...prev,
            remolquePlaca: rem.placa || "",
            economicor: rem.economico || "",
          }));
        }
        // Verificar si el remolque full seleccionado tiene un GPS fijo vinculado (por placa)
        if (rem.placa) {
          getfuntion("get", [], "", "remolquesGpsFijos/placa/" + encodeURIComponent(rem.placa) + "/activo", "gpsFijoVinculadoFull");
        }
      }
    } else {
      setRemolqueFullSeleccionado(null);
      setRemolqueFullActualObj(null);
      setIdRemolqueFull({ value: 0, label: "Seleccione una Opción" });
      setMovimientosPatiosFull(prev => ({
        ...prev,
        remolquePlaca: "",
        economicor: "",
        idRemolque: { idRemolque: 0 },
      }));
    }
  };

  // ═══ HANDLERS DE VINCULACIÓN (botón morado) ═══
  // Estos handlers pre-llenan los formularios con datos del histórico (movimientos_patio)
  // para crear o vincular operadores/tractos/remolques que existen en el histórico pero no en el catálogo

  const getOperadorElementosParaVincular = () => {
    // Pre-llenar con datos del histórico para crear/vincular operador
    // Dividimos desde el final: última palabra=materno, penúltima=paterno, el resto=nombre
    const nombreCompleto = movimientosPatios.operadorNombre || "";
    const partes = nombreCompleto.trim().split(/\s+/);
    let nombre = "";
    let paterno = "";
    let materno = "";

    if (partes.length >= 4) {
      materno = partes[partes.length - 1];
      paterno = partes[partes.length - 2];
      nombre = partes.slice(0, partes.length - 2).join(" ");
    } else if (partes.length === 3) {
      nombre = partes[0];
      paterno = partes[1];
      materno = partes[2];
    } else if (partes.length === 2) {
      nombre = partes[0];
      paterno = partes[1];
    } else {
      nombre = partes[0] || "";
    }

    return {
      nombre: nombre,
      paterno: paterno,
      materno: materno,
      medioComunicacion: movimientosPatios.operadorContacto || "",
      licenciaTipo: movimientosPatios.operadorLicencia || "",
      nombreCompleto: nombreCompleto,
    };
  };

  const getTractoElementosParaVincular = () => {
    // Pre-llenar con datos del histórico para crear/vincular tracto
    return {
      placa: movimientosPatios.tractorPlaca || "",
      economico: movimientosPatios.economicot || "",
      color: movimientosPatios.tractorColor || "",
      modelo: movimientosPatios.tractorModelo || "",
      // idUnidadMarca se buscará por nombre en TractosForm
      idUnidadMarca: movimientosPatios.tractorMarca
        ? { nombre: movimientosPatios.tractorMarca }
        : null,
    };
  };

  const getRemolqueElementosParaVincular = () => {
    // Pre-llenar con datos del histórico para crear/vincular remolque
    return {
      placa: movimientosPatios.remolquePlaca || "",
      economico: movimientosPatios.economicor || "",
      remolquesTipos: movimientosPatios.idRemolque?.idRemolque
        ? { idRemolque: movimientosPatios.idRemolque.idRemolque, nombre: movimientosPatios.idRemolque.nombre }
        : null,
    };
  };

  const getRemolqueFullElementosParaVincular = () => {
    // Pre-llenar con datos del histórico para crear/vincular remolque full
    return {
      placa: movimientosPatiosFull.remolquePlaca || "",
      economico: movimientosPatiosFull.economicor || "",
      remolquesTipos: movimientosPatiosFull.idRemolque?.idRemolque
        ? { idRemolque: movimientosPatiosFull.idRemolque.idRemolque, nombre: movimientosPatiosFull.idRemolque.nombre }
        : null,
    };
  };

  // ═══ CALLBACKS onSave para modales (después de crear/editar) ═══
  const handleOperadorGuardado = (operadorData) => {
    // Recargar con TODOS los hermanos, no solo el principal
    if (idsTransportistasHermanos.length > 0) {
      cargarOperadoresPorTransportistas(idsTransportistasHermanos);
    } else if (idTransportista) {
      cargarOperadoresPorTransportistas([idTransportista]);
    }
    const nuevoNombre = operadorData.nombreCompleto || `${operadorData.nombre} ${operadorData.paterno || ""} ${operadorData.materno || ""}`.trim();
    setMovimientosPatios(prev => ({
      ...prev,
      operadorNombre: nuevoNombre,
      operadorContacto: operadorData.medioComunicacion || "",
      operadorLicencia: operadorData.licenciaTipo || "",
    }));
    // Auto-seleccionar el nuevo/editado
    setTimeout(() => {
      setOperadorSeleccionado({ value: operadorData.id, label: nuevoNombre, data: operadorData });
      setOperadorActualObj(operadorData);
    }, 500);
  };

  const handleTractoGuardado = (tractoData) => {
    // Recargar con TODOS los hermanos, no solo el principal
    if (idsTransportistasHermanos.length > 0) {
      cargarTractosPorTransportistas(idsTransportistasHermanos);
    } else if (idTransportista) {
      cargarTractosPorTransportistas([idTransportista]);
    }
    // Obtener nombre de marca: primero del objeto expandido, luego por lookup
    let marcaNombre = "";
    if (tractoData.idUnidadMarca?.nombre) {
      marcaNombre = tractoData.idUnidadMarca.nombre;
    } else if (tractoData.idUnidadMarca?.id && unidadesMarcasMap[tractoData.idUnidadMarca.id]) {
      marcaNombre = unidadesMarcasMap[tractoData.idUnidadMarca.id];
    }
    setMovimientosPatios(prev => ({
      ...prev,
      tractorModelo: tractoData.modelo || "",
      tractorMarca: marcaNombre,
      tractorColor: tractoData.color || "",
      tractorPlaca: tractoData.placa || "",
      economicot: tractoData.economico || "",
    }));
    setTimeout(() => {
      const label = tractoData.placa || "";
      setTractoSeleccionado({ value: tractoData.id, label, data: tractoData });
      setTractoActualObj(tractoData);
    }, 500);
  };

  const handleRemolqueGuardado = (remolqueData) => {
    // Recargar con TODOS los hermanos, no solo el principal
    if (idsTransportistasHermanos.length > 0) {
      cargarRemolquesPorTransportistas(idsTransportistasHermanos);
    } else if (idTransportista) {
      cargarRemolquesPorTransportistas([idTransportista]);
    }
    // Actualizar tipo de plataforma si viene en los datos guardados
    if (remolqueData.remolquesTipos) {
      setIdRemolque({ value: remolqueData.remolquesTipos.idRemolque, label: remolqueData.remolquesTipos.nombre, data: remolqueData.remolquesTipos });
      setMovimientosPatios(prev => ({
        ...prev,
        remolquePlaca: remolqueData.placa || "",
        economicor: remolqueData.economico || "",
        idRemolque: remolqueData.remolquesTipos,
      }));
    } else {
      setMovimientosPatios(prev => ({
        ...prev,
        remolquePlaca: remolqueData.placa || "",
        economicor: remolqueData.economico || "",
      }));
    }
    setTimeout(() => {
      const label = remolqueData.placa || "";
      setRemolqueSeleccionado({ value: remolqueData.idRemolque, label, data: remolqueData });
      setRemolqueActualObj(remolqueData);
    }, 500);
  };

  const handleRemolqueFullGuardado = (remolqueData) => {
    // Recargar con TODOS los hermanos, no solo el principal
    if (idsTransportistasHermanos.length > 0) {
      cargarRemolquesPorTransportistas(idsTransportistasHermanos);
    } else if (idTransportista) {
      cargarRemolquesPorTransportistas([idTransportista]);
    }
    // Actualizar tipo de plataforma full si viene en los datos guardados
    if (remolqueData.remolquesTipos) {
      setIdRemolqueFull({ value: remolqueData.remolquesTipos.idRemolque, label: remolqueData.remolquesTipos.nombre, data: remolqueData.remolquesTipos });
      setMovimientosPatiosFull(prev => ({
        ...prev,
        remolquePlaca: remolqueData.placa || "",
        economicor: remolqueData.economico || "",
        idRemolque: remolqueData.remolquesTipos,
      }));
    } else {
      setMovimientosPatiosFull(prev => ({
        ...prev,
        remolquePlaca: remolqueData.placa || "",
        economicor: remolqueData.economico || "",
      }));
    }
    setTimeout(() => {
      const label = remolqueData.placa || "";
      setRemolqueFullSeleccionado({ value: remolqueData.idRemolque, label, data: remolqueData });
      setRemolqueFullActualObj(remolqueData);
    }, 500);
  };

  /**
   * Resuelve el objeto de tipo de colocación "GPS FIJO" desde el catálogo real
   * (gpstipocolocaciones) en lugar de asumir un id fijo. Busca por nombre.
   * Devuelve un objeto con la forma { value, label, data } compatible con el Select
   * y con la lógica de agregado (usa .data.id y .label).
   */
  const resolverTipoGpsFijo = () => {
    // gpstipocolocaciones incluye el placeholder {value:0,...}; buscamos por nombre
    const encontrado = gpstipocolocaciones.find(
      (t) => t.data && typeof t.label === "string" &&
        t.label.toUpperCase().trim().includes("FIJO")
    );
    if (encontrado) {
      return { value: encontrado.value, label: encontrado.label, data: encontrado.data };
    }
    // Fallback: si el catálogo no trae un tipo "FIJO", usar id 6 como último recurso
    return { value: 6, label: "GPS FIJO", data: { id: 6, nombre: "GPS FIJO" } };
  };

  /**
   * Auto-agrega un GPS fijo vinculado a la lista de GPS del movimiento,
   * replicando la lógica del botón "+" (validaciones + carga de datos del GPS
   * vía gpsestatus para llenar DATOS GPS / NIVEL BATERIA / ULTIMO REPORTE).
   * @param {Object} gpsVinc  GPS COMPLETO (traído de gps/{id}, con gpsHardware y gpsEstatus)
   * @param {Object} tipoGpsFijo  { value, label, data: { id, nombre } } resuelto del catálogo
   * @param {boolean} esFullTarget  true => agrega a gpsAgregadosFull; false => a gpsAgregado
   */
  const agregarGpsFijoALista = (gpsVinc, tipoGpsFijo, esFullTarget = false) => {
    if (!gpsVinc || !gpsVinc.id) return;

    // Evitar duplicados: mismo GPS o mismo tipo ya agregado en la lista destino,
    // o el mismo GPS ya asociado al otro movimiento.
    const listaActual = esFullTarget ? gpsAgregadosFull : gpsAgregado;
    const otraLista = esFullTarget ? gpsAgregado : gpsAgregadosFull;

    if (listaActual.find((o) => o.id === gpsVinc.id)) return; // ya está
    if (listaActual.find((o) => o.tipoid && o.tipoid.id === tipoGpsFijo.data.id)) return; // ya hay un GPS FIJO
    if (otraLista.find((o) => o.id === gpsVinc.id)) return; // ya asociado al otro movimiento

    const plataformaId = movimientoPrimario?.idPlataforma?.id;

    const insertarFila = (datos = {}) => {
      const fila = {
        id: gpsVinc.id,
        nombre: gpsVinc.nombre,
        tipoid: tipoGpsFijo.data,
        tipo: tipoGpsFijo.label,
        direccion: datos?.direccion || "",
        nivelbateria: datos?.nivel_bateria || "",
        ultimo_reporte: datos?.ultimo_reporte || "",
        gps: gpsVinc,
        mov: esFullTarget ? movimientoFull : movimientoPrimario,
      };
      if (esFullTarget) {
        setGpsAgregadosFull((prev) =>
          prev.find((o) => o.id === gpsVinc.id) ? prev : [...prev, fila]
        );
      } else {
        setGpsAgregado((prev) =>
          prev.find((o) => o.id === gpsVinc.id) ? prev : [...prev, fila]
        );
      }
    };

    // Cargar datos del GPS (dirección, batería, último reporte) y luego agregar la fila.
    // Se garantiza que movimientoPrimario ya está cargado porque este flujo se dispara
    // desde el handler "movimientosPatio", que solo corre tras poblar movimientoPrimario.
    if (plataformaId) {
      getfuntion(
        "get",
        [],
        "",
        "gpsestatus/plataforma/" + plataformaId + "/gps/" + gpsVinc.id,
        "datosGps"
      ).then((datos) => {
        insertarFila(datos);
      }).catch(() => {
        insertarFila({});
      });
    } else {
      insertarFila({});
    }
  };

  const cargaGps= async( mov= {})=>{
    // primario obtener gps
    if(!mov.id)
      return;
    let gpsAgregadoTemp= [];
    for(let mg of mov.movimientoGps){
      let datosGpsTemp= {};
      try{
        await getfuntion( "get", [], "", "gpsestatus/plataforma/"+mov.idPlataforma.id+"/gps/" + mg.gps.id, "datosGps" ).then((resp) => {
          datosGpsTemp= resp || {};
        });
      }catch(err){
        console.log("no se ha recuperado el estatus del gps "+mg.gps.nombre);
      }

      gpsAgregadoTemp.push({
        id: mg.gps.id,
        nombre: mg.gps.nombre,
        tipoid: mg.gpsTipo,
        tipo: mg.gpsTipo.nombre,
        direccion: datosGpsTemp?.direccion || "",
        nivelbateria: datosGpsTemp?.nivel_bateria || "",
        ultimo_reporte: datosGpsTemp?.ultimo_reporte || "",
        gps: mg.gps,
        mov: mov,
      });
    }
    gpsAgregadoOld= gpsAgregadoTemp;
    setGpsAgregado(gpsAgregadoTemp);
    if(guardando){
      setSaveProgress({ ...saveProgress, activeStep: 4  });
      if(!Number(movimientosPatios.esFull)){
        //refrescar();
        NotificationManager.success("Guardado", "Guardado" );
        guardando = false;// disabledButon es false, se inicia evento guardar
        setDisabledButon(false);
      }
    }
  }

  useEffect(()=>{
    if (movimientoFull.id) {
      if (!movimientoFull.idPlataforma.zonaHoraria)
      movimientoFull.idPlataforma.zonaHoraria = "";
      // secundario obtener patio
      //getfuntion("get", [], "", "movimientosPatio/idMovimiento/" + movimientoFull.id, "movimientosPatioFull" );

      //if(!movimientosPatiosFull.id){alert("es nuevo")
        getfuntion("get", [], "", "movimientosPatio/idMovimiento/" + movimientoFull.id, "movimientosPatioFull" );
        const mptFullTemp= movimientosSinGps.filter(ms=> ms.value === movimientoFull.id);
        setMovimientoSecundario(mptFullTemp[0]? mptFullTemp[0]: { value: 0, label: "Seleccione un Movimiento", data: null});
      //}
      if(!guardando){
        cargaGpsFull(movimientoFull);
      }
    }
  },[movimientoFull]);

  const cargaGpsFull= async( mov= {})=>{
    // primario obtener gps
    if(!mov.id)
      return;
    let gpsAgregadoTemp= [];
    for(let mg of mov.movimientoGps){
      let datosGpsTemp= {};
      try{
        await getfuntion( "get", [], "", "gpsestatus/plataforma/"+mov.idPlataforma.id+"/gps/" + mg.gps.id, "datosGps" ).then((resp) => {
          datosGpsTemp= resp || {};
        });
      }catch(err){
        console.log("no se ha recuperado el estatus del gps "+mg.gps.nombre);
      }

      gpsAgregadoTemp.push({
        id: mg.gps.id,
        nombre: mg.gps.nombre,
        tipoid: mg.gpsTipo,
        tipo: mg.gpsTipo.nombre,
        direccion: datosGpsTemp?.direccion || "",
        nivelbateria: datosGpsTemp?.nivel_bateria || "",
        ultimo_reporte: datosGpsTemp?.ultimo_reporte || "",
        gps: mg.gps,
        mov: mov,
      });
    }
    gpsAgregadosFullOld= gpsAgregadoTemp;
    setGpsAgregadosFull(gpsAgregadoTemp);
    if(guardando){
      await new Promise(r => setTimeout(r, 5000));
      setSaveProgressFull({ ...saveProgress, activeStep: 4  });
      //refrescar();
      NotificationManager.success("Guardado", "Guardado" );
      guardando = false;// disabledButon es false, se inicia evento guardar
      setDisabledButon(false);
    }
  }

  useEffect(()=>{
    if(movimientosPatios.id && guardando){
      cargaGps(movimientoPrimario);
    }

    // AGREGADO: Recargar GPS cuando se carga un movimiento con diferente movimientoLocal
    if (movimientosPatios.id && !guardando) {
      const estatusActual = obtenerEstatusGps(movimientosPatios.movimientoLocal);
      //console.log("Movimiento cargado con movimientoLocal:", movimientosPatios.movimientoLocal);
      //console.log("Recargando GPS con estatus:", estatusActual);
      cargarGpsSegunMovimientoLocal(movimientosPatios.movimientoLocal);
    }

    if( movimientosPatiosFull.idMovimiento){
      setMovimientosPatiosFull(
        {...movimientosPatiosFull,
          economicot: movimientosPatios.economicot,
          idRemolque: movimientosPatios.idRemolque,
          operadorNombre: movimientosPatios.operadorNombre,
          operadorContacto: movimientosPatios.operadorContacto,
          operadorLicencia: movimientosPatios.operadorLicencia,
          tractorModelo: movimientosPatios.tractorModelo,
          tractorMarca: movimientosPatios.tractorMarca,
          tractorColor: movimientosPatios.tractorColor,
          enProtocolo: movimientosPatios.enProtocolo,
          movimientoLocal: movimientosPatios.movimientoLocal,
          tractorPlaca: movimientosPatios.tractorPlaca,
          colocacionFecha: movimientosPatios.colocacionFecha,
          idLocalidad: movimientosPatios.idLocalidad,
          idUsuario: movimientosPatios.idUsuario,
        });
    }
  },[movimientosPatios]);

  useEffect(()=>{
    if(movimientosPatiosFull.id && guardando){
      cargaGpsFull(movimientoFull);
    }
  },[movimientosPatiosFull]);

  const buscarFull= async (id)=>{
    await getfuntion( "get", [], "", "navieraMovimientos/" +  id, "movimientoFull" );
    if(guardando){
      setSaveProgressFull({ ...saveProgress, activeStep: 2  });
      await new Promise(r => setTimeout(r, 2000));
    }
  }
  const getfuntion = (
    metodo = "get",
    obj = [],
    id = "",
    catalogo = "",
    stateVar = "",
    hiddenModl = ""
  ) => {
    return Crud_Catalogos(
      catalogo,
      "movimientos",
      metodo,
      id,
      obj,
      "",
      stateVar,
      hiddenModl,
      []
    ).then((returnVal) => {
      switch (metodo) {
        case "post":
          {
            if (stateVar === "movimientosPatios") {
              return returnVal;
            }
            if (stateVar === "movimientoGp") {
              return returnVal;
            }
            if (stateVar === "asignar_gps") {
              return true;
            }
            if (stateVar === "sendMail") {
              return returnVal;
            }
          }
          break;
        case "get":
          {
            if (stateVar === "remolquesTipo") {
              let remolquesTipoTem = [{ value: 0, label: "Seleccione una opción" }, ];
              for( let r of returnVal ){
                remolquesTipoTem.push({ value: r.idRemolque, label: r.nombre, data: r });
              }
              setRemolques(remolquesTipoTem);
            }
            if (stateVar === "gpsGateEtiquetas") {
              setGpsGateEtiquetas(returnVal);
              setUpdateMSG(true);//Valida Etiquetas(De no estar la  equieteta no se ra posible configurar)
            }
            if (stateVar === "gpstipocolocacion") {
              let gpstipocolocacionTem = [{ value: 0, label: "Seleccione una opción" }, ];
              for( let gtc of returnVal ){
                gpstipocolocacionTem.push({ value: gtc.id, label: gtc.nombre, data: gtc });
              }
              setGpstipocolocaciones(gpstipocolocacionTem);
            }
            if (stateVar === "usuarios") {
              let usuariosTem = [{ value: 0, label: "Seleccione una opción" }];
              returnVal.map((u, index) =>
                usuariosTem.push({
                  value: u.id,
                  label: u.nombre + " " + u.aPaterno + " " + u.aMaterno,
                  data: u,
                })
              );
              setUsuarios(usuariosTem);
            }
            if (stateVar === "movimiento") {
              setMovimientoPrimario(returnVal);
              return returnVal;
            }
            if (stateVar === "gpsestatus") {
              return returnVal;
            }
            if (stateVar === "gpsCompleto") {
              // GPS completo (con gpsHardware y gpsEstatus) traído desde gps/{id}
              return returnVal;
            }
            if (stateVar === "movimientoFull") {
              setMovimientoFull(returnVal);
              return returnVal;
            }
            if (stateVar === "movimientosPatio") {
              let patioTemp= {...returnVal};
              if( patioTemp.id ){
                if(guardando){
                  setSaveProgress({ ...saveProgress, activeStep: 3  });
                }
                setMovimientosPatios({...returnVal });
                setIdRemolque( { value: returnVal.idRemolque.idRemolque, label: returnVal.idRemolque.nombre, data: returnVal.idRemolque } );
                if(Number(patioTemp.esFull)){
                  setEsFull(true);
                  buscarFull(Number(patioTemp.esFull));
                }
                // Verificar si el remolque tiene un GPS fijo vinculado (por placa)
                if( returnVal.remolquePlaca ){
                  getfuntion("get", [], "", "remolquesGpsFijos/placa/" + encodeURIComponent(returnVal.remolquePlaca) + "/activo", "gpsFijoVinculado");
                }
              }else{
                setMovimientosPatios({...movimientosPatios, idLocalidad: movimientoPrimario.idLocalidad, idMovimiento: idMovimiento });
                setMovimientosPatiosFull({...movimientosPatiosFull, idLocalidad: movimientoPrimario.idLocalidad });
              }
              return returnVal;
            }
            if (stateVar === "gpsFijoVinculado") {
              // Si el remolque está vinculado a un GPS fijo, pre-llenar TIPO GPS y NOMBRE GPS
              if( returnVal && returnVal.gps && returnVal.gps.id ){
                const gpsVincParcial = returnVal.gps;
                // TIPO GPS = "GPS FIJO" resuelto desde el catálogo real (no id fijo)
                const tipoGpsFijo = resolverTipoGpsFijo();
                setTipoColocacion(tipoGpsFijo);
                // Cargar el GPS COMPLETO (gpsHardware, gpsEstatus) para que el Select,
                // el botón "+" y el guardado funcionen correctamente.
                getfuntion("get", [], "", "gps/" + gpsVincParcial.id, "gpsCompleto")
                  .then((gpsCompleto) => {
                    const gpsFinal = (gpsCompleto && gpsCompleto.id) ? gpsCompleto : gpsVincParcial;
                    // NOMBRE GPS = el gps vinculado (con data completa)
                    setGps({ value: gpsFinal.id, label: gpsFinal.nombre, data: gpsFinal });
                    // Asegurar que el gps aparezca en la lista de opciones
                    setGpsList((prev) => {
                      const yaExiste = prev.some((g) => g.value === gpsFinal.id);
                      if (yaExiste) return prev;
                      return [...prev, { value: gpsFinal.id, label: gpsFinal.nombre, data: gpsFinal }];
                    });
                    // Auto-agregar el GPS fijo a la lista (equivalente al botón "+")
                    agregarGpsFijoALista(gpsFinal, tipoGpsFijo, false);
                  })
                  .catch(() => {
                    // Fallback: usar el objeto parcial aunque esté incompleto
                    setGps({ value: gpsVincParcial.id, label: gpsVincParcial.nombre, data: gpsVincParcial });
                    setGpsList((prev) => {
                      const yaExiste = prev.some((g) => g.value === gpsVincParcial.id);
                      if (yaExiste) return prev;
                      return [...prev, { value: gpsVincParcial.id, label: gpsVincParcial.nombre, data: gpsVincParcial }];
                    });
                    agregarGpsFijoALista(gpsVincParcial, tipoGpsFijo, false);
                  });
              }
              return returnVal;
            }
            if (stateVar === "movimientosPatioFull") {
              if( returnVal.id ){
                if(guardando){
                  setSaveProgressFull({ ...saveProgress, activeStep: 3  });
                }
                setMovimientosPatiosFull({...returnVal });
                if (returnVal.idRemolque && returnVal.idRemolque.idRemolque) {
                  setIdRemolqueFull({ value: returnVal.idRemolque.idRemolque, label: returnVal.idRemolque.nombre, data: returnVal.idRemolque });
                }
                // Verificar si el remolque del full tiene un GPS fijo vinculado (por placa)
                if( returnVal.remolquePlaca ){
                  getfuntion("get", [], "", "remolquesGpsFijos/placa/" + encodeURIComponent(returnVal.remolquePlaca) + "/activo", "gpsFijoVinculadoFull");
                }
              }
              return returnVal;
            }
            if (stateVar === "gpsFijoVinculadoFull") {
              // Si el remolque del full está vinculado a un GPS fijo, pre-llenar TIPO GPS FULL y NOMBRE GPS FULL
              if( returnVal && returnVal.gps && returnVal.gps.id ){
                const gpsVincParcial = returnVal.gps;
                const tipoGpsFijo = resolverTipoGpsFijo();
                setTipoColocacionFull(tipoGpsFijo);
                getfuntion("get", [], "", "gps/" + gpsVincParcial.id, "gpsCompleto")
                  .then((gpsCompleto) => {
                    const gpsFinal = (gpsCompleto && gpsCompleto.id) ? gpsCompleto : gpsVincParcial;
                    setGpsFull({ value: gpsFinal.id, label: gpsFinal.nombre, data: gpsFinal });
                    setGpsList((prev) => {
                      const yaExiste = prev.some((g) => g.value === gpsFinal.id);
                      if (yaExiste) return prev;
                      return [...prev, { value: gpsFinal.id, label: gpsFinal.nombre, data: gpsFinal }];
                    });
                    agregarGpsFijoALista(gpsFinal, tipoGpsFijo, true);
                  })
                  .catch(() => {
                    setGpsFull({ value: gpsVincParcial.id, label: gpsVincParcial.nombre, data: gpsVincParcial });
                    setGpsList((prev) => {
                      const yaExiste = prev.some((g) => g.value === gpsVincParcial.id);
                      if (yaExiste) return prev;
                      return [...prev, { value: gpsVincParcial.id, label: gpsVincParcial.nombre, data: gpsVincParcial }];
                    });
                    agregarGpsFijoALista(gpsVincParcial, tipoGpsFijo, true);
                  });
              }
              return returnVal;
            }
            if (stateVar === "gpsDisponible") {
              let gpsListTemp= [{ value: 0, label: "Seleccione un GPS", data: null }];
              //console.log(`Procesando ${returnVal.length} GPS para estatus solicitado`);
              returnVal.map((g, index) => {
                // Opcional: mostrar el estatus en el label para claridad
                const estatusInfo = g.gpsEstatus ? ` (${g.gpsEstatus.nombre})` : '';
                gpsListTemp.push({ 
                  value: g.id, 
                  label: g.nombre,
                  //label: g.nombre + estatusInfo, 
                  data: g
                });
              });
              setGpsList(gpsListTemp);
              //console.log(`GPS cargados: ${gpsListTemp.length - 1} para movimientoLocal: ${movimientosPatios.movimientoLocal}`);
              //Gps Instalado por ahora solo se mostrarn los gps marcados como disponibles
              //getfuntion("get", [], "", "gps/idestatus/2", "gpsAsignado"); //Gps Instalado
              //getfuntion("get", [], "", "gpsMobile/idGpsEstatus/2", "gpsAsignado"); //Gps Disponibles
            }
            if (stateVar === "gpsAsignado") {
              let gpsListTemp = [...gpsList];
              returnVal.map((g, index) => {
                gpsListTemp.push({ value: g.id, label: g.nombre, data: g, });
              });
              setGpsList(gpsListTemp);
            }
            if (stateVar === "datosGps") {//revisar
              setDatosGps(returnVal);
              return returnVal;
            }
          }
          break;
        default:
          break;
      }
    });
  };

  const reset=()=>{
    setMovimientosPatiosFull(
      {
        idMovimiento: null,//verificar
        economicor: "",//*
        economicot: "",
        idRemolque: { idRemolque: 0 },
        operadorNombre: "",
        operadorContacto: "",
        operadorLicencia: "",
        tractorModelo: "",
        tractorMarca: "",
        tractorColor: "",
        enProtocolo: true,
        tractorPlaca: "",
        esFull: "",
        remolquePlaca: "",//*
        colocacionFecha: null,
        observaciones: "",//*
        idLocalidad: null,
        idUsuario: usuario,
      }
    );
    setMovimientosPatios(
      {
        idMovimiento: null,
        economicor: "",//*
        economicot: "",//*
        idRemolque: { idRemolque: 0 },
        operadorNombre: "",
        operadorContacto: "",
        operadorLicencia: "",
        tractorModelo: "",
        tractorMarca: "",
        tractorColor: "",
        enProtocolo: true,
        tractorPlaca: "",
        esFull: "",
        remolquePlaca: "",//*
        colocacionFecha: null,
        observaciones: "",
        idLocalidad: null,
        idUsuario: usuario,
      }
    );

    setMovimientoPrimario({});
    setMovimientoFull({});


    gpsAgregadosFullOld= [];
    setGpsAgregadosFull(gpsAgregadosFullOld);

    gpsAgregadoOld= [];
    setGpsAgregado(gpsAgregadoOld);
    setEsFull(false);
    // Reset estados de catálogos para evitar datos stale
    setOperadorSeleccionado(null);
    setOperadorActualObj(null);
    setTractoSeleccionado(null);
    setTractoActualObj(null);
    setRemolqueSeleccionado(null);
    setRemolqueActualObj(null);
    setRemolqueFullSeleccionado(null);
    setRemolqueFullActualObj(null);
    setCatalogosListos(false);
  }
  const recuperarGPS = (gpsAgregadoRec) => {
    const recGps = { gps: gpsAgregadoRec.id, plataforma: gpsAgregadoRec.mov.idPlataforma.id, estatus: 1, idMovimiento: gpsAgregadoRec.mov.id };
    getfuntion("post", recGps, "", "gps/remover_activo", "removerActivo").then(
      (gpsEstatus) => {
        Crud_Catalogos("usuariosLog", "nada", "post", "", {
          idBitacoraMonitoreo: 5,
          idUsuario: usuario.id,
          idMovimiento: gpsAgregadoRec.mov.id,
          accionFecha: timeToDateFill(new Date().getTime()),
          descripcion: "Remover GPS activo: " + gpsAgregadoRec.nombre + "(" + gpsAgregadoRec.id + ")",
          idPlataformaTipo: 1,
        });
      }
    );
  };
  const agregarGPS = async () => {
    let movGpsTemp= {};
    NotificationManager.info("Guardando datos ... ", "Guardar");
    setSaveProgress({ ...saveProgress, activeStep: 0 });

    if (guardando) {//ya se ha dado un click
      return true;
    }
    guardando = true;// disabledButon es false, se inicia evento guardar
    setDisabledButon(true);

    if ( !movimientosPatios.idRemolque["idRemolque"] ) {
      setSaveProgress({ ...saveProgress, isStepFailed: 0, stepFailedMessage: "Tipo de plataforma requerido"  });
      NotificationManager.warning(
        "Tipo de plataforma requerido ..!",
        "Atención"
      );
      guardando = false;// disabledButon es false, se inicia evento guardar
      setDisabledButon(false);
      return;
    }

    //verifica si hay movmiento full
    if (  esFull && !Number(movimientosPatiosFull.esFull) ) {
        setSaveProgress({ ...saveProgress, isStepFailed: 0, stepFailedMessage: "Se ha detectado que quiere hacer full con: " + movimientoSecundario.label + " (pero, no ha completado los datos)"  });
      NotificationManager.warning(
        "Se ha detectado que quiere hacer full con: " + movimientoSecundario.label + " (pero, no ha completado los datos)",
        "Guardar"
      );
      guardando = false;// disabledButon es false, se inicia evento guardar
      setDisabledButon(false);
      return;
    }

    //guardando movimiento patio
    /*
    if ( movimientoSecundario.value ) {
      movimientosPatios.esFull = movimientoSecundario.value;

      movimientosPatiosFull.idMovimiento = movimientoSecundario.value;
      movimientosPatiosFull.esFull = idMovimiento;
    } else {
      movimientosPatios["esFull"] = "";
    }*/

    await getfuntion(
      (movimientosPatios.id? "put": "post"),
      movimientosPatios,
      "",
      "movimientosPatio",
      "movimientosPatios"
    ).catch((err) => {
      setSaveProgress({ ...saveProgress, isStepFailed: 0, stepFailedMessage: "Error al guardar datos del tracto y del operador"  });
      NotificationManager.error(
        "Error al guardar datos del tracto y del operador",
        "Error"
      );
      guardando = false;// disabledButon es false, se inicia evento guardar
      setDisabledButon(false);
      return;
    });

    /**
       * Mov Full
       */
    setSaveProgressFull({ ...saveProgress, activeStep: 0 });
    if(movimientoSecundario.value || Number(movimientosPatios.esFull)){
      await getfuntion(
        (movimientosPatiosFull.id? "put": "post"),
        movimientosPatiosFull,
        "",
        "movimientosPatio",
        "movimientosPatiosFull"
      ).catch((err) => {
        NotificationManager.error(
          "Error al guardar datos del tracto y del operador",
          "Error"
        );
        guardando = false;// disabledButon es false, se inicia evento guardar
        setDisabledButon(false);
        return;
      });
    }
    setSaveProgress({ ...saveProgress, activeStep: 1  });
    //Guardando movmiento gps's
    if ( !gpsAgregado.length ) {
      NotificationManager.warning("No se han agregado GPS'S", "Atención");
    }
    //Borrar gps
    for( let viejo of gpsAgregadoOld ) {
      let eliminar = true;
      for (let nuevo of gpsAgregado) {
        if (viejo.id === nuevo.id)
          eliminar = false;
      }
      if (eliminar) {//Se borrara gps
        recuperarGPS(viejo);
      }
    }
    for (let nuevo of gpsAgregado) {
      let actualizar = false;
      let datoViejo = false;
      for (let viejo of gpsAgregadoOld) {
        if (viejo.id === nuevo.id) {
          datoViejo = true;
          if (viejo.tipoid !== nuevo.tipoid) {
            actualizar = true;
          }
        }
      }
      let movimientosGps = {
        idMovimiento: idMovimiento,
        gps: nuevo.gps,
        gpsTipo: nuevo.tipoid,
        espejo: nuevo.gps.gpsEstatus.id === 1 ? false : 
         (nuevo.gps.gpsEstatus.id === 2 ? !movimientosPatios.movimientoLocal : true),
      };
      if ( actualizar || !datoViejo ) {
        //Radio operado, sin gps, aqui se vinculan a l mov( No cambia el estatus del gps)(No recibiran alertas, actualizacion automatica, )
        await getfuntion( "post", movimientosGps, "", "movimientoGps", "movimientoGp" ).then((movGps) => {
          if(!movGpsTemp[movimientosGps.idMovimiento]){
            movGpsTemp[movimientosGps.idMovimiento]= {};
          }
          movGpsTemp[movimientosGps.idMovimiento][nuevo.id]= movGps;
          NotificationManager.info(
            "Gps: " + nuevo.nombre + " agregado",
            "Guardado"
          );
        }).catch((err) => {
          NotificationManager.error(
            "Hubo un error al vincular el gps al movimiento",
            "Error"
          );
        });
        const usuariosLogObject = {
          idBitacoraMonitoreo: 5,
          idUsuario: usuario.id,
          idMovimiento: idMovimiento,
          accionFecha: timeToDateFill( new Date().getTime()),
          descripcion: "Asignacion de GPS: " + nuevo.nombre + "(" + nuevo.id + ")",
          idPlataformaTipo: 1,
        };
        await Crud_Catalogos(
          "usuariosLog",
          "nada",
          "post",
          "",
          usuariosLogObject
        );
      }
      //etiquetado gate
      if ((actualizar || !datoViejo) && nuevo.id > 20) {
        const gpsGG = {
          gps: nuevo.id,
          plataforma: plataformaid,
          estatus: 2,
          idMovimiento: idMovimiento,
        };
        await getfuntion(
          "post",
          gpsGG,
          "",
          "gps/asignar_gps",
          "asignar_gps"
        ).then((respuesta) => {
          //Si se tiene la función de refetch se realiza para volver a cargar la petición principal
          if (refetch) {
            refetch();
          }
        })
        .catch((err) => {
        });
      }

    }
    /**
     * Mov Full
     */
    setSaveProgressFull({ ...saveProgress, activeStep: 1  });
    const idMovimientoFull = movimientoSecundario.value || Number(movimientosPatios.esFull);
    if(idMovimientoFull){
      if ( !gpsAgregado.length || !gpsAgregadosFull.length ) {
        NotificationManager.warning("No se han agregado GPS'S", "Atención");
      }
      for( let viejo of gpsAgregadosFullOld ){
        let eliminar = true;
        for (let nuevo of gpsAgregadosFull) {
          if (viejo.id === nuevo.id) {
            eliminar = false;
          }
        }
        if (eliminar) {//Se borrara gps
          recuperarGPS(viejo);
        }
      }
      for (let nuevo of gpsAgregadosFull) {
        let actualizar = false;
        let datoViejo = false;
        for (let viejo of gpsAgregadosFullOld) {
          if (viejo.id === nuevo.id) {
            datoViejo = true;
            if (viejo.tipoid !== nuevo.tipoid) {
              actualizar = true;
            }
          }
        }
        let movimientosGpsFull = {
          idMovimiento: idMovimientoFull,
          gps: nuevo.gps,
          gpsTipo: nuevo.tipoid,
          espejo: nuevo.gps.gpsEstatus.id === 1 ? false : 
              (nuevo.gps.gpsEstatus.id === 2 ? !movimientosPatios.movimientoLocal : true),
        };
        //Radio operado, sin gps, aqui se vinculan a l mov( No cambia el estatus del gps)(No recibiran alertas, actualizacion automatica, )
        await getfuntion(
          "post",
          movimientosGpsFull,
          "",
          "movimientoGps",
          "movimientoGp"
        ).then((movGps) => {
          if(!movGpsTemp[movimientosGpsFull.idMovimiento]){
            movGpsTemp[movimientosGpsFull.idMovimiento]= {};
          }
          movGpsTemp[movimientosGpsFull.idMovimiento][nuevo.id]= movGps;
          NotificationManager.info(
            "Gps: " + nuevo.nombre + " agregado",
            "Guardado"
          );
        })
        .catch((err) => {
          NotificationManager.error(
            "Hubo un error al vincular el gps al movimiento",
            "Error"
          );
        });
        const usuariosLogObject = {
          idBitacoraMonitoreo: 5,
          idUsuario: usuario.id,
          idMovimiento: idMovimientoFull,
          accionFecha: timeToDateFill( new Date().getTime()),
          descripcion: "Asignacion de GPS: " + nuevo.nombre + "(" + nuevo.id + ")",
          idPlataformaTipo: 1,
        };
        await Crud_Catalogos(
          "usuariosLog",
          "nada",
          "post",
          "",
          usuariosLogObject
        );

        if ((actualizar || !datoViejo) && nuevo.id > 20) {
          const gpsGG = {
            gps: nuevo.id,
            plataforma: plataformaid,
            estatus: 2,
            idMovimiento: idMovimientoFull,
          };
          /** Asignar Gps en GG */
          await getfuntion("post", gpsGG, "", "gps/asignar_gps").then((respuestaGG) => {
            //Si se tiene la función de refetch se realiza para volver a cargar la petición principal
            if (refetch) {
              refetch();
            }
          })
          .catch((err) => {
          });
        }
      }
    }

    if( Object.keys(images).length ){
      //imagesTemp[gpsDis.mov][gpsDis.id]
      for (let mov in images) {
        for (let gps in images[mov]) {
          let formData = new FormData();
          //formData.append("images[]",images[mov][gps]);
          images[mov][gps].forEach((image) => {
            formData.append('images', image); // 'images' es el nombre que espera el servidor
          });
          const mGps= movGpsTemp[mov][gps];
          await Crud_Catalogos("uploadImagesMovGps/"+mGps.id+"/asignacion", "cargar_evidencias", "post", "", formData).then((returnVal) => {
              }).catch(err =>{ console.log("error: "+err);});
        }
      }
    }/*
    if( movimientoPrimario.id && gpsAgregado.length &&
      (  !movimientosPatios.operadorNombre || !movimientosPatios.operadorNombre.length
      || !movimientosPatios.operadorContacto || !movimientosPatios.operadorContacto.length
      || !movimientosPatios.tractorMarca || !movimientosPatios.tractorMarca.length
      || !movimientosPatios.tractorColor || !movimientosPatios.tractorColor.length
      || !movimientosPatios.tractorModelo || !movimientosPatios.tractorModelo.length
      || !movimientosPatios.tractorPlaca || !movimientosPatios.tractorPlaca.length
      || !movimientosPatios.remolquePlaca || !movimientosPatios.remolquePlaca.length
      || !movimientosPatios.economicot || !movimientosPatios.economicot.length)
      ){
        setSaveProgress({ ...saveProgress, isStepFailed: 0, stepFailedMessage: "no se captura datos de operador"  });//activeStep: null, isStepFailed: null
        await getfuntion("post",{}, "", "mail/arrobanaviera/"+movimientosPatios.idMovimiento+"/12", "sendMail").then((returnVal) => {
          NotificationManager.info(returnVal, "Notificación datos faltantes" );
        });
    }
    if(movimientoSecundario.value && gpsAgregadosFull.length &&
      (    !movimientosPatiosFull.operadorNombre || !movimientosPatiosFull.operadorNombre.length
      || !movimientosPatiosFull.operadorContacto || !movimientosPatiosFull.operadorContacto.length
      || !movimientosPatiosFull.tractorMarca || !movimientosPatiosFull.tractorMarca.length
      || !movimientosPatiosFull.tractorColor || !movimientosPatiosFull.tractorColor.length
      || !movimientosPatiosFull.tractorModelo || !movimientosPatiosFull.tractorModelo.length
      || !movimientosPatiosFull.tractorPlaca || !movimientosPatiosFull.tractorPlaca.length
      || !movimientosPatiosFull.remolquePlaca || !movimientosPatiosFull.remolquePlaca.length
      || !movimientosPatiosFull.economicot || !movimientosPatiosFull.economicot.length)
      ){
        setSaveProgress({ ...saveProgress, isStepFailed: 0, stepFailedMessage: "no se captura datos de operador"  });//activeStep: null, isStepFailed: null
        await getfuntion("post",{}, "", "mail/arrobanaviera/"+movimientosPatiosFull.idMovimiento+"/12", "sendMail").then((returnVal) => {
          NotificationManager.info(returnVal, "Notificación datos faltantes" );
        });
    }*/
    reset();
    await new Promise(r => setTimeout(r, 2000));
    setSaveProgress({ ...saveProgress, activeStep: 2  });
    // Obtener el movimiento actualizado y completar la verificación directamente
    // en lugar de depender del encadenamiento de useEffects (evita race condition)
    const movActualizado = await getfuntion( "get", [], "", "navieraMovimientos/" + movimiento.idMovimiento, "movimiento" );
    if(movActualizado && movActualizado.id){
      setSaveProgress({ ...saveProgress, activeStep: 3  });
      await cargaGps(movActualizado);
      // Si cargaGps no desbloqueó el botón (caso full u otro), forzar desbloqueo
      if(guardando){
        setSaveProgress({ ...saveProgress, activeStep: 4  });
        NotificationManager.success("Guardado", "Guardado");
        guardando = false;
        setDisabledButon(false);
      }
    } else {
      // Fallback: si no se pudo obtener el movimiento, desbloquear de todas formas
      // El guardado ya se completó (pasos 1 y 2), solo falló la verificación
      setSaveProgress({ ...saveProgress, activeStep: 4  });
      NotificationManager.warning("Guardado, pero no se pudo verificar", "Atención");
      guardando = false;
      setDisabledButon(false);
    }
  }
  return (
    <div>
      <div className="row">
        <div className="col">
          <div>
            <div class="row">
              <div className="col col-12 col-sm-12 col-md-12 ">
                {updateMSG ? (
                  <div hidden={gpsGateEtiquetas.id}>
                    <Alert type="danger" icon="alert-octagon">
                      {" "}
                      Pide a sistemas que configure la etiqueta plataforma en
                      gpsgate, para poder asignar gps
                    </Alert>
                  </div>
                ) : null}
                {/* AGREGAR INDICADOR VISUAL PARA MOVIMIENTO LOCAL */}
                <div className="col col-12 col-sm-12 col-md-12">
                  {movimientosPatios.movimientoLocal ? (
                     <Alert type="info" icon="info">
                      <strong>Movimiento Local:</strong> Se muestran GPS con estatus 1,2 (Disponibles + Asignados/Instalados)
                    </Alert>
                  ) : (
                    <Alert type="default">
                      <strong>Movimiento Normal:</strong> Se muestran GPS con estatus 1 (Disponibles)
                    </Alert>
                  )}
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div className="col col-12 col-sm-12 col-md-4 ">
                    <Form.Group label="Usuario que coloca(Para un usuario diferente ingrese nombre)">
                      <Select
                        value={controlador}
                        onChange={(selectedOption)=>{
                          if (selectedOption && selectedOption.data) {
                            setControlador(selectedOption);
                            setMovimientosPatios({...movimientosPatios, idUsuario: selectedOption.data });
                          } else {
                            // Manejar deselección
                            setControlador({ value: 0, label: "Seleccione una opción", data: null });
                            setMovimientosPatios({...movimientosPatios, idUsuario: null });
                          }
                        }}
                        options={usuarios}
                        onInputChange={(e)=>{
                          if (e.length > 1) {
                            getfuntion(
                              "get",
                              "",
                              "",
                              "personas/nombre_o_apellido_y_perfil?nombre=" +
                                encodeURIComponent(e) +
                                "&perfil=222",
                              "usuarios"
                            );
                          }
                        }}
                        maxMenuHeight={200}
                      />{" "}
                    </Form.Group>
                  </div>
                  <div className="col col-12 col-sm-12 col-md-4 ">
                    <Form.Group label="En protocolo">
                      <Form.Switch
                        name="enProtocolo"
                        type="Checkbox"
                        label={
                          movimientosPatios.enProtocolo
                            ? "Dentro de protocolo"
                            : "Fuera de protocolo"
                        }
                        onChange={(e)=> setMovimientosPatios({...movimientosPatios, enProtocolo: e.target.checked }) }
                        checked={movimientosPatios.enProtocolo}
                      />
                    </Form.Group>
                  </div>
                  {/* <div className="col col-12 col-sm-12 col-md-4 ">
                    <Form.Group label="Movimiento Local">
                      <Form.Switch
                        name="movimientoLocal"
                        type="Checkbox"
                        label={
                          movimientosPatios.movimientoLocal
                            ? "Local"
                            : "No Local"
                        }
                        onChange={(e)=> {
                          const nuevoValor = e.target.checked;
                          const nuevoEstatus = obtenerEstatusGps(nuevoValor);                          
                          // Debug
                          //console.log(`Cambio movimientoLocal: ${nuevoValor} -> Estatus GPS: ${nuevoEstatus}`);                          
                          // Actualizar estado
                          setMovimientosPatios({...movimientosPatios, movimientoLocal: nuevoValor });                          
                          // Resetear selecciones GPS
                          resetearSeleccionesGps();                          
                          // Cargar GPS con nuevo estatus
                          cargarGpsSegunMovimientoLocal(nuevoValor);                          
                          // Mostrar notificación al usuario
                          NotificationManager.info(
                            `Cargando GPS con estatus ${nuevoEstatus} para movimiento ${nuevoValor ? 'local' : 'normal'}`,
                            "Información"
                          );
                        }}
                        checked={movimientosPatios.movimientoLocal}
                      />
                    </Form.Group>
                  </div> */}
                </div>
              </div>
              <div className="col col-12 col-sm-12 col-md-12 ">
                {" "}
                {/*Datos de tractor */}
                <h3 style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>TRACTO
                  {(!tractoSeleccionado && catalogosListos) ? (
                    <ModalLay
                      tamanio="60%"
                      title="Nuevo Tracto"
                      name={<Button size="sm" color="success" outline><Icon name="plus" /> Nuevo</Button>}
                      formulario={TractosForm}
                      datosForm={{ accion: "nuevo", idTransportista: idTransportista, onSave: handleTractoGuardado }}
                    />
                  ) : (!tractoSeleccionado && !catalogosListos && movimientosPatios.tractorPlaca) ? (
                    <span style={{ fontSize: "12px", color: "#888" }}>Cargando catálogo...</span>
                  ) : (
                    tractoActualObj ? (
                      <ModalLay
                        tamanio="60%"
                        title="Editar Tracto"
                        name={<Button size="sm" color="primary" outline><Icon name="edit" /> Editar</Button>}
                        formulario={TractosForm}
                        datosForm={{ accion: "editar", elementos: tractoActualObj && tractoActualObj.idUnidadMarca && !tractoActualObj.idUnidadMarca.nombre && unidadesMarcasMap[tractoActualObj.idUnidadMarca.id]
                          ? { ...tractoActualObj, idUnidadMarca: { ...tractoActualObj.idUnidadMarca, nombre: unidadesMarcasMap[tractoActualObj.idUnidadMarca.id] } }
                          : tractoActualObj, idTransportista: idTransportista, onSave: handleTractoGuardado }}
                      />
                    ) : tractoSeleccionado ? (
                      <>
                        <Button size="sm" color="warning" outline style={{ whiteSpace: "nowrap" }} onClick={() => NotificationManager.warning("Este tracto no existe en el catálogo de tractos de ninguno de los transportistas hermanos", "No encontrado")}>
                          <Icon name="edit" /> Editar
                        </Button>
                        <ModalLay
                          tamanio="60%"
                          title="Vincular Tracto"
                          name={<Button size="sm" className="btn-vincular-purple" style={{ whiteSpace: "nowrap" }}><Icon name="link" /> Vincular</Button>}
                          formulario={TractosForm}
                          datosForm={{ accion: "nuevo", elementos: getTractoElementosParaVincular(), idTransportista: idTransportista, onSave: handleTractoGuardado }}
                        />
                      </>
                    ) : null
                  )}
                </h3>
                <div class="row">
                  <div className="col col-12 col-sm-12 col-md-3 ">
                    <Form.Group label="Modelo Tractor">
                      {" "}
                      <Form.Input
                        name="modeloTractor"
                        type="text"
                        value={movimientosPatios.tractorModelo}
                        onChange={(e)=> setMovimientosPatios({...movimientosPatios, tractorModelo: e.target.value }) }
                        readOnly={true}
                        style={{ backgroundColor: "#f0f0f0" }}
                      />{" "}
                    </Form.Group>
                  </div>
                  <div className="col col-12 col-sm-12 col-md-3 ">
                    <Form.Group label="Marca Tractor">
                      {" "}
                      <Form.Input
                        name="marcaTractor"
                        type="text"
                        value={movimientosPatios.tractorMarca}
                        onChange={(e)=> setMovimientosPatios({...movimientosPatios, tractorMarca: e.target.value }) }
                        readOnly={true}
                        style={{ backgroundColor: "#f0f0f0" }}
                      />{" "}
                    </Form.Group>
                  </div>
                  <div className="col col-12 col-sm-12 col-md-3 ">
                    <Form.Group label="Color Tractor">
                      {" "}
                      <Form.Input
                        name="colorTractor"
                        type="text"
                        value={movimientosPatios.tractorColor}
                        onChange={(e)=> setMovimientosPatios({...movimientosPatios, tractorColor: e.target.value }) }
                        readOnly={true}
                        style={{ backgroundColor: "#f0f0f0" }}
                      />{" "}
                    </Form.Group>
                  </div>
                  <div className="col col-12 col-sm-12 col-md-3 ">
                    <Form.Group label="Placa Tractor">
                      <Select
                        value={tractoSeleccionado}
                        onChange={handleSeleccionarTracto}
                        options={tractosOpciones}
                        isClearable={true}
                        placeholder={movimientosPatios.tractorPlaca && !catalogosListos 
                          ? `${movimientosPatios.tractorPlaca} (cargando catálogo...)` 
                          : "Buscar por placa..."}
                        noOptionsMessage={() => catalogosListos ? "Sin tractos" : "Cargando catálogo..."}
                        isLoading={!catalogosListos && !!idTransportista}
                        maxMenuHeight={200}
                        pageSize={20}
                      />
                    </Form.Group>
                  </div>
                  <div className="col col-12 col-sm-12 col-md-3 ">
                    <Form.Group label="Economico(Tracto)">
                      {" "}
                      <Form.Input
                        name="economicot"
                        type="text"
                        value={movimientosPatios.economicot}
                        onChange={(e)=> setMovimientosPatios({...movimientosPatios, economicot: e.target.value }) }
                        readOnly={true}
                        style={{ backgroundColor: "#f0f0f0" }}
                      />{" "}
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>

            <hr style={estilo} />
            <h3 style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>OPERADOR
              {(!operadorSeleccionado && catalogosListos) ? (
                <ModalLay
                  tamanio="60%"
                  title="Nuevo Operador"
                  name={<Button size="sm" color="success" outline><Icon name="plus" /> Nuevo</Button>}
                  formulario={OperadoresFormSimple}
                  datosForm={{ accion: "nuevo", idTransportista: idTransportista, onSave: handleOperadorGuardado }}
                />
              ) : (!operadorSeleccionado && !catalogosListos && movimientosPatios.operadorNombre) ? (
                <span style={{ fontSize: "12px", color: "#888" }}>Cargando catálogo...</span>
              ) : (
                operadorActualObj ? (
                  <ModalLay
                    tamanio="60%"
                    title="Editar Operador"
                    name={<Button size="sm" color="primary" outline><Icon name="edit" /> Editar</Button>}
                    formulario={OperadoresFormSimple}
                    datosForm={{ accion: "modificar", elementos: operadorActualObj, idTransportista: idTransportista, onSave: handleOperadorGuardado }}
                  />
                ) : operadorSeleccionado ? (
                  <>
                    <Button size="sm" color="warning" outline style={{ whiteSpace: "nowrap" }} onClick={() => NotificationManager.warning("Este operador no existe en el catálogo de operadores de ninguno de los transportistas hermanos", "No encontrado")}>
                      <Icon name="edit" /> Editar
                    </Button>
                    <ModalLay
                      tamanio="60%"
                      title="Vincular Operador"
                      name={<Button size="sm" className="btn-vincular-purple" style={{ whiteSpace: "nowrap" }}><Icon name="link" /> Vincular</Button>}
                      formulario={OperadoresFormSimple}
                      datosForm={{ accion: "nuevo", elementos: getOperadorElementosParaVincular(), idTransportista: idTransportista, onSave: handleOperadorGuardado }}
                    />
                  </>
                ) : null
              )}
            </h3>

            <div class="row">
              {" "}
              {/* Datos del operador */}
              <div className="col col-12 col-sm-12 col-md-4 ">
                <Form.Group label="Nombre Operador">
                  <Select
                    value={operadorSeleccionado}
                    onChange={handleSeleccionarOperador}
                    options={operadoresOpciones}
                    isClearable={true}
                    placeholder={movimientosPatios.operadorNombre && !catalogosListos 
                      ? `${movimientosPatios.operadorNombre} (cargando catálogo...)` 
                      : "Buscar operador..."}
                    noOptionsMessage={() => catalogosListos ? "Sin operadores" : "Cargando catálogo..."}
                    isLoading={!catalogosListos && !!idTransportista}
                    maxMenuHeight={200}
                    pageSize={20}
                  />
                </Form.Group>
              </div>
              <div className="col col-12 col-sm-12 col-md-4 ">
                <Form.Group label="Medio Contacto">
                  {" "}
                  <Form.Input
                    name="medioContacto"
                    type="text"
                    value={movimientosPatios.operadorContacto}
                    onChange={(e)=> setMovimientosPatios({...movimientosPatios, operadorContacto: e.target.value }) }
                    readOnly={true}
                    style={{ backgroundColor: "#f0f0f0" }}
                  />{" "}
                </Form.Group>
              </div>
              <div className="col col-12 col-sm-12 col-md-4 ">
                <Form.Group label="Licencia">
                  {" "}
                  <Form.Input
                    name="licencia"
                    type="text"
                    value={movimientosPatios.operadorLicencia}
                    onChange={(e)=> setMovimientosPatios({...movimientosPatios, operadorLicencia: e.target.value }) }
                    readOnly={true}
                    style={{ backgroundColor: "#f0f0f0" }}
                  />{" "}
                </Form.Group>
              </div>
            </div>

            <hr style={estilo} />

            <div class="row">
              {/** Asignacion de gps */}
              <Card title={<h3 style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>GPS(requerido)
                {(!remolqueSeleccionado && catalogosListos) ? (
                  <ModalLay
                    tamanio="50%"
                    title="Nuevo Remolque"
                    name={<Button size="sm" color="success" outline><Icon name="plus" /> Nuevo Remolque</Button>}
                    formulario={RemolquesForm}
                    datosForm={{ accion: "nuevo", idTransportista: idTransportista, onSave: handleRemolqueGuardado }}
                  />
                ) : (!remolqueSeleccionado && !catalogosListos && movimientosPatios.remolquePlaca) ? (
                  <span style={{ fontSize: "12px", color: "#888" }}>Cargando catálogo...</span>
                ) : (
                  remolqueActualObj ? (
                    <ModalLay
                      tamanio="50%"
                      title="Editar Remolque"
                      name={<Button size="sm" color="primary" outline><Icon name="edit" /> Editar Remolque</Button>}
                      formulario={RemolquesForm}
                      datosForm={{ accion: "editar", elementos: remolqueActualObj, idTransportista: idTransportista, onSave: handleRemolqueGuardado }}
                    />
                  ) : remolqueSeleccionado ? (
                    <>
                      <Button size="sm" color="warning" outline style={{ whiteSpace: "nowrap" }} onClick={() => NotificationManager.warning("Este remolque no existe en el catálogo de remolques de ninguno de los transportistas hermanos", "No encontrado")}>
                        <Icon name="edit" /> Editar Remolque
                      </Button>
                      <ModalLay
                        tamanio="50%"
                        title="Vincular Remolque"
                        name={<Button size="sm" className="btn-vincular-purple" style={{ whiteSpace: "nowrap" }}><Icon name="link" /> Vincular Remolque</Button>}
                        formulario={RemolquesForm}
                        datosForm={{ accion: "nuevo", elementos: getRemolqueElementosParaVincular(), idTransportista: idTransportista, onSave: handleRemolqueGuardado }}
                      />
                    </>
                  ) : null
                )}
              </h3>} isCollapsible>
                <Card.Body>
                  <div class="row">
                    <div className="col col-12 col-sm-12 col-md-4 ">
                      <Form.Group label="Placa Remolque">
                        <Select
                          value={remolqueSeleccionado}
                          onChange={handleSeleccionarRemolque}
                          options={remolquesOpciones}
                          isClearable={true}
                          placeholder={movimientosPatios.remolquePlaca && !catalogosListos 
                            ? `${movimientosPatios.remolquePlaca} (cargando catálogo...)` 
                            : "Buscar por placa..."}
                          noOptionsMessage={() => catalogosListos ? "Sin remolques" : "Cargando catálogo..."}
                          isLoading={!catalogosListos && !!idTransportista}
                          maxMenuHeight={200}
                          pageSize={20}
                        />
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-4 ">
                      <Form.Group label="Economico (remolque)">
                        {" "}
                        <Form.Input
                          name="economicor"
                          type="text"
                          value={movimientosPatios.economicor}
                          onChange={(e)=> setMovimientosPatios({...movimientosPatios, economicor: e.target.value }) }
                          readOnly={true}
                          style={{ backgroundColor: "#f0f0f0" }}
                        />{" "}
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-4 ">
                      <Form.Group label="Observaciones">
                        {" "}
                        <Form.Textarea
                          name="observaciones"
                          onChange={(e)=> setMovimientosPatios({...movimientosPatios, observaciones: e.target.value }) }
                        >{movimientosPatios.observaciones}</Form.Textarea>{" "}
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-4 ">
                      <Form.Group label="Tipo Plataforma(requerido)">
                        <Form.Input
                          name="tipoPlataforma"
                          type="text"
                          value={idRemolque.label !== "Seleccione una Opción" ? idRemolque.label : ""}
                          readOnly={true}
                          style={{ backgroundColor: "#f0f0f0" }}
                          placeholder="Se asigna automáticamente al seleccionar remolque"
                        />
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-3 ">
                      <Form.Group label="ID MOVIMIENTO - PO-CONTENEDOR">
                        {" "}
                        <Form.Input
                          name="movRoot"
                          type="text"
                          value={movimiento.idMovimiento+" - "+movimiento.po+ " - "+ movimiento.contenedor}
                        />{" "}
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-3 ">
                      <Form.Group label="NOMBRE GPS (búsqueda opcional)">
                        {" "}
                        <Select
                          value={gps}
                          onChange={(selectedOption)=>{
                            if (selectedOption && selectedOption.value && selectedOption.value > 0) {
                              setDatosGps({});
                              if (movimientoPrimario?.idPlataforma?.idGg) {
                                getfuntion(
                                  "get",
                                  [],
                                  "",
                                  "gpsestatus/plataforma/"+movimientoPrimario.idPlataforma.id+"/gps/" + selectedOption.value,
                                  "datosGps"
                                );
                              }
                              setGps(selectedOption);
                            } else {
                              // Manejar deselección
                              setDatosGps({});
                              setGps({ value: 0, label: "Seleccione un GPS", data: null });
                            }
                          }}
                          onInputChange={(inputValue, actionMeta) => {
                            // Solo buscar cuando el usuario está escribiendo
                            if (actionMeta.action === 'input-change') {
                              // Usar debounce para no hacer muchas peticiones
                              clearTimeout(window.gpsSearchTimeout);
                              window.gpsSearchTimeout = setTimeout(() => {
                                buscarGpsPorNombre(inputValue);
                              }, 500); // Esperar 500ms después de que el usuario deje de escribir
                            }
                          }}
                          options={gpsList.filter( g=> gpsAgregado.filter( ga => ga.id === g.value).length === 0 || gpsAgregadosFull.filter( ga => ga.id === g.value).length === 0 )}
                          isClearable={true}
                          placeholder="Buscar GPS por nombre..."
                          noOptionsMessage={() => "No se encontraron GPS"}
                          loadingMessage={() => "Buscando GPS..."}
                          maxMenuHeight={200}
                          pageSize={20}
                        />{" "}
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-3 ">
                      <Form.Group label="TIPO GPS">
                        <Select
                          value={tipoColocacion}
                          onChange={(selectedOption)=> {
                            if (selectedOption && selectedOption.value) {
                              setTipoColocacion(selectedOption);
                            } else {
                              setTipoColocacion({ value: 0, label: "Seleccione una opción", data_: null });
                            }
                          }}
                          isClearable={true}
                          options={gpstipocolocaciones}
                          maxMenuHeight={200}
                        />{" "}
                      </Form.Group>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-3 ">
                      <Button
                        onClick={() => {
                          if ( !gps.data.gpsHardware.id === 0 ) {
                            NotificationManager.error(
                              `No se puede asignar el GPS ${gps.data.nombre}, ya que no cuenta con la información del hardaware, contacte a la persona responsable.`,
                              "Error"
                            );
                            return;
                          }

                          if (
                            gpsAgregado.find((objectGPS) => objectGPS.tipoid.id === tipoColocacion.value)) {
                            NotificationManager.error(
                              `Ya se ha agregado un GPS de tipo ${tipoColocacion.label} al movimiento`,
                              "Error"
                            );
                            return;
                          }

                          if (gpsAgregadosFull.find( (objectGPS) => objectGPS.id === gps.value)) {
                            NotificationManager.error(
                              `No se puede agregar el GPS ${gps.data.nombre}, ya se encuentra asociado a otro movimiento.`,
                              "Error"
                            );
                            return;
                          }
                          let gpsAgregadoTemp= [...gpsAgregado];
                          gpsAgregadoTemp.push({
                            id: gps.value,
                            nombre: gps.label,
                            tipoid: tipoColocacion.data,
                            tipo: tipoColocacion.label,
                            direccion: datosGps?.direccion || "",
                            nivelbateria: datosGps?.nivel_bateria || "",
                            ultimo_reporte: datosGps?.ultimo_reporte || "",
                            gps: gps.data,
                            mov: movimientoPrimario,
                          });
                          setGpsAgregado(gpsAgregadoTemp);
                          setGps({ value: 0, label: "Seleccione un GPS", data: null });
                          setTipoColocacion({ value: 0, label: "Seleccione una opción", data_: null });
                        }}
                        pill
                        color="primary"
                        outline
                        disabled={
                          !gps.value || !tipoColocacion.value
                        }
                      >
                        <i
                          class="fa fa-plus"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="agregar GPS"
                        ></i>
                      </Button>
                    </div>
                    <div className="col col-12 col-sm-12 col-md-12 ">
                      <Table
                        cards={true}
                        striped={true}
                        responsive={true}
                        className="table-vcenter"
                      >
                        <Table.Header align="center">
                          <Table.ColHeader> ID </Table.ColHeader>
                          <Table.ColHeader> NOMBRE GPS </Table.ColHeader>
                          <Table.ColHeader> TIPO GPS </Table.ColHeader>
                          <Table.ColHeader> DATOS GPS </Table.ColHeader>
                          <Table.ColHeader> NIVEL BATERIA GPS </Table.ColHeader>
                          <Table.ColHeader> ULTIMO REPORTE </Table.ColHeader>
                          <Table.ColHeader> EVIDENCIAS</Table.ColHeader>
                          {/* <Table.ColHeader> BORRAR </Table.ColHeader> */}
                        </Table.Header>
                        <Table.Body>
                          { gpsAgregado.map((gpsDis, index) => (
                            <Table.Row align="center">
                              <Table.Col> {gpsDis.id} </Table.Col>
                              <Table.Col> {gpsDis.nombre} </Table.Col>
                              <Table.Col> {gpsDis.tipo} </Table.Col>
                              <Table.Col> {gpsDis.direccion} </Table.Col>
                              <Table.Col>
                                {gpsDis.nivelbateria <= "100" &&
                                gpsDis.nivelbateria >= "80" ? (
                                  <Icon prefix="fa" name="battery-4" />
                                ) : null}
                                {gpsDis.nivelbateria <= "79" &&
                                gpsDis.nivelbateria >= "55" ? (
                                  <Icon prefix="fa" name="battery-3" />
                                ) : null}
                                {gpsDis.nivelbateria <= "54" &&
                                gpsDis.nivelbateria >= "41" ? (
                                  <Icon prefix="fa" name="battery-2" />
                                ) : null}
                                {gpsDis.nivelbateria <= "40" &&
                                gpsDis.nivelbateria >= "25" ? (
                                  <Icon prefix="fa" name="battery" />
                                ) : null}
                                {gpsDis.nivelbateria >= "0" &&
                                gpsDis.nivelbateria <= "24" ? (
                                  <Icon prefix="fa" name="battery-0" />
                                ) : null}
                                {gpsDis.nivelbateria} %
                              </Table.Col>
                              <Table.Col> {gpsDis.ultimo_reporte} </Table.Col>
                              <Table.Col>
                                <div>
                                  <input
                                    type="file"
                                    className=""
                                    multiple
                                    onChange={(event) => {
                                      let imagesTemp= {...images};
                                      if(!imagesTemp[gpsDis.mov.id]){
                                        imagesTemp[gpsDis.mov.id]= {};
                                      }
                                      if(!imagesTemp[gpsDis.mov.id][gpsDis.id]){
                                        imagesTemp[gpsDis.mov.id][gpsDis.id]= [];
                                      }
                                      imagesTemp[gpsDis.mov.id][gpsDis.id]= [...event.target.files];
                                      //console.log(imagesTemp);
                                      setImages(imagesTemp);
                                    }}
                                  />
                                  <div>
                                    {images[gpsDis.mov.id]?.[gpsDis.id]?.map((image, index) => (
                                      <img key={index} src={URL.createObjectURL(image)} alt={image.name} width={"80px"}/>
                                    ))}
                                  </div>
                                </div>
                              </Table.Col>
                              <Table.Col>
                                <span
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title={
                                    gpsAgregadoOld.filter(go => go.id === gpsDis.id).length?
                                      "Solicita esta acción a la central de monitoreo(Los gps ya guardos, solo pueden removerse por la central)"
                                    : "Remover gps"
                                  }
                                >
                                  {puedeEliminarGps && (
                                    <Button
                                      onClick={() =>{
                                        Crud_Catalogos(
                                          "usuariosLog",
                                          "nada",
                                          "post",
                                          "",
                                          {
                                            idBitacoraMonitoreo: 5,
                                            idUsuario: sessionUser.id,
                                            idMovimiento: idMovimiento,
                                            accionFecha: timeToDateFill(new Date().getTime()),
                                            descripcion: "Eliminacion de GPS: " + gpsDis.nombre + "(" + gpsDis.id + ")",
                                            idPlataformaTipo: 1,
                                          }
                                        ).then(() => {
                                          let gpsAgregadoTem= [...gpsAgregado];
                                          gpsAgregadoTem.splice(index, 1);
                                          setGpsAgregado(gpsAgregadoTem);
                                        }).catch(() => {
                                          NotificationManager.error("No se pudo registrar el log, el GPS no fue removido", "Error");
                                        });
                                      }}
                                      color="danger"
                                    >
                                      Borrar
                                    </Button>
                                  )}
                                </span>
                              </Table.Col>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </div>
                  <div class="row"></div>
                </Card.Body>
              </Card>
            </div>

            <hr style={estilo} />

            <div class="row">
              {/**  Movimientos en full, debe de tomarse como una nueva asignacion*/}
              <Form.Switch
                type="Checkbox"
                label={esFull ? "Movimiento en full" : "Colocar en full"}
                checked={esFull}
                onChange={(e)=> setEsFull(e.target.checked)}
              />

              {/* <Form.Switch
                type="Checkbox"
                label={dentroDeProtocolo ? "Dentro de protocolo" : "Fuera de protocolo"}
                //checked={dentroDeProtocolo}
                onChange={changeDentroDeProtocolo}
              /> */}

              {esFull ? (
                <Card title={<h3 style={{ display: "inline-flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>MOVIMIENTO FULL
                  {(!remolqueFullSeleccionado && catalogosListos) ? (
                    <ModalLay
                      tamanio="50%"
                      title="Nuevo Remolque"
                      name={<Button size="sm" color="success" outline><Icon name="plus" /> Nuevo Remolque</Button>}
                      formulario={RemolquesForm}
                      datosForm={{ accion: "nuevo", idTransportista: idTransportista, onSave: handleRemolqueFullGuardado }}
                    />
                  ) : (!remolqueFullSeleccionado && !catalogosListos && movimientosPatiosFull.remolquePlaca) ? (
                    <span style={{ fontSize: "12px", color: "#888" }}>Cargando catálogo...</span>
                  ) : (
                    remolqueFullActualObj ? (
                      <ModalLay
                        tamanio="50%"
                        title="Editar Remolque"
                        name={<Button size="sm" color="primary" outline><Icon name="edit" /> Editar Remolque</Button>}
                        formulario={RemolquesForm}
                        datosForm={{ accion: "editar", elementos: remolqueFullActualObj, idTransportista: idTransportista, onSave: handleRemolqueFullGuardado }}
                      />
                    ) : remolqueFullSeleccionado ? (
                      <>
                        <Button size="sm" color="warning" outline style={{ whiteSpace: "nowrap" }} onClick={() => NotificationManager.warning("Este remolque no existe en el catálogo de remolques de ninguno de los transportistas hermanos", "No encontrado")}>
                          <Icon name="edit" /> Editar Remolque
                        </Button>
                        <ModalLay
                          tamanio="50%"
                          title="Vincular Remolque Full"
                          name={<Button size="sm" className="btn-vincular-purple" style={{ whiteSpace: "nowrap" }}><Icon name="link" /> Vincular Remolque</Button>}
                          formulario={RemolquesForm}
                          datosForm={{ accion: "nuevo", elementos: getRemolqueFullElementosParaVincular(), idTransportista: idTransportista, onSave: handleRemolqueFullGuardado }}
                        />
                      </>
                    ) : null
                  )}
                </h3>} isCollapsible>
                  <Card.Body>
                    <div class="row">
                      <div className="col col-12 col-sm-12 col-md-4">
                        <Form.Group label="ID MOVIMIENTO- PO -CONTENEDOR FULL (requerido)">
                          <Select
                            value={movimientoSecundario}
                            onChange={(selectedOption)=>{
                              if (selectedOption && selectedOption.value && selectedOption.value > 0) {
                                setMovimientoSecundario(selectedOption);
                                setMovimientosPatiosFull({
                                  ...movimientosPatiosFull,
                                  esFull: movimiento.idMovimiento,
                                  idMovimiento: Number(selectedOption.value),
                                  remolquePlaca: "",
                                  economicor: "",
                                  observaciones: "",
                                });
                                setMovimientosPatios({...movimientosPatios, esFull: selectedOption.value });
                                getfuntion( "get", [], "", "navieraMovimientos/" +  selectedOption.value, "movimientoFull" );
                              } else {
                                // Manejar deselección
                                setMovimientoSecundario({ value: 0, label: "Seleccione un Movimiento", data: null });
                                setMovimientosPatiosFull({
                                  ...movimientosPatiosFull,
                                  esFull: "",
                                  idMovimiento: null,
                                  remolquePlaca: "",
                                  economicor: "",
                                  observaciones: "",
                                });
                                setMovimientosPatios({...movimientosPatios, esFull: "" });
                              }
                            }}
                            isClearable={true}
                            options={movimientosSinGps}
                            isDisabled={Number(movimientosPatios.esFull)}
                            maxMenuHeight={200}
                            pageSize={20}
                          />
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-4 ">
                        <Form.Group label="Placa Remolque">
                          <Select
                            value={remolqueFullSeleccionado}
                            onChange={handleSeleccionarRemolqueFull}
                            options={remolquesOpciones}
                            isClearable={true}
                            placeholder={movimientosPatiosFull.remolquePlaca && !catalogosListos 
                              ? `${movimientosPatiosFull.remolquePlaca} (cargando catálogo...)` 
                              : "Buscar por placa..."}
                            noOptionsMessage={() => catalogosListos ? "Sin remolques" : "Cargando catálogo..."}
                            isLoading={!catalogosListos && !!idTransportista}
                            maxMenuHeight={200}
                            pageSize={20}
                          />
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-4 ">
                        <Form.Group label="Economico (Remolque)">
                          {" "}
                          <Form.Input
                            name="economicorF"
                            type="text"
                            value={movimientosPatiosFull.economicor}
                            onChange={(e)=> setMovimientosPatiosFull({...movimientosPatiosFull, economicor: e.target.value }) }
                            readOnly={true}
                            style={{ backgroundColor: "#f0f0f0" }}
                          />{" "}
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-4 ">
                        <Form.Group label="Tipo Plataforma(requerido)">
                          <Form.Input
                            name="tipoPlataformaFull"
                            type="text"
                            value={idRemolqueFull.label !== "Seleccione una Opción" ? idRemolqueFull.label : ""}
                            readOnly={true}
                            style={{ backgroundColor: "#f0f0f0" }}
                            placeholder="Se asigna automáticamente al seleccionar remolque"
                          />
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-4 ">
                        <Form.Group label="Observaciones">
                          {" "}
                          <Form.Textarea
                            name="observacionesF"
                            onChange={(e)=> setMovimientosPatiosFull({...movimientosPatiosFull, observaciones: e.target.value }) }
                          >{movimientosPatiosFull.observaciones}</Form.Textarea>{" "}
                        </Form.Group>
                      </div>
                    </div>

                    <hr style={estilo} />
                    <div class="row">
                      <div className="col col-12 col-sm-12 col-md-3 ">
                        <Form.Group label="NOMBRE GPS FULL (búsqueda opcional)">
                          <Select
                            value={gpsFull}
                            onChange={(selectedOption)=>{
                              if (selectedOption && selectedOption.value && selectedOption.value > 0) {
                                if (movimientoFull?.idPlataforma?.idGg) {
                                  getfuntion(
                                    "get",
                                    [],
                                    "",
                                    "gpsestatus/plataforma/"+movimientoFull.idPlataforma.id+"/gps/" + selectedOption.value,
                                    "datosGps"
                                  );
                                }
                                setGpsFull(selectedOption);
                              } else {
                                // Manejar deselección
                                setGpsFull({ value: 0, label: "Seleccione un GPS", data: null });
                              }
                            }}
                            onInputChange={(inputValue, actionMeta) => {
                              // Solo buscar cuando el usuario está escribiendo
                              if (actionMeta.action === 'input-change') {
                                // Usar debounce para no hacer muchas peticiones
                                clearTimeout(window.gpsSearchTimeoutFull);
                                window.gpsSearchTimeoutFull = setTimeout(() => {
                                  buscarGpsPorNombre(inputValue);
                                }, 500); // Esperar 500ms después de que el usuario deje de escribir
                              }
                            }}
                            options={gpsList.filter( g=> gpsAgregado.filter( ga => ga.id === g.value).length === 0 || gpsAgregadosFull.filter( ga => ga.id === g.value).length === 0 )}
                            isClearable={true}
                            placeholder="Buscar GPS por nombre..."
                            noOptionsMessage={() => "No se encontraron GPS"}
                            loadingMessage={() => "Buscando GPS..."}
                            maxMenuHeight={200}
                            pageSize={20}
                          />
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-3 ">
                        <Form.Group label="TIPO GPS FULL">
                          {" "}
                          <Select
                            value={tipoColocacionFull}
                            onChange={(selectedOption)=> {
                              if (selectedOption && selectedOption.value) {
                                setTipoColocacionFull(selectedOption);
                              } else {
                                setTipoColocacionFull({ value: 0, label: "Seleccione una opción", data_: null });
                              }
                            }}
                            isClearable={true}
                            options={gpstipocolocaciones}
                            maxMenuHeight={200}
                          />{" "}
                        </Form.Group>
                      </div>
                      <div className="col col-12 col-sm-12 col-md-3 ">
                        <Button
                          onClick={() => {
                            if ( !gpsFull.data.gpsHardware.id === 0 ) {
                              NotificationManager.error(
                                `No se puede asignar el GPS ${gpsFull.data.nombre}, ya que no cuenta con la información del hardaware, contacte a la persona responsable.`,
                                "Error"
                              );
                              return;
                            }

                            if (
                              gpsAgregadosFull.find((objectGPS) => objectGPS.tipoid.id === tipoColocacionFull.value)) {
                              NotificationManager.error(
                                `Ya se ha agregado un GPS de tipo ${tipoColocacionFull.label} al movimiento`,
                                "Error"
                              );
                              return;
                            }

                            if (gpsAgregado.find( (objectGPS) => objectGPS.id === gpsFull.value)) {
                              NotificationManager.error(
                                `No se puede agregar el GPS ${gpsFull.data.nombre}, ya se encuentra asociado a otro movimiento.`,
                                "Error"
                              );
                              return;
                            }
                            let gpsAgregadoTemp= [...gpsAgregadosFull];
                            gpsAgregadoTemp.push({
                              id: gpsFull.value,
                              nombre: gpsFull.label,
                              tipoid: tipoColocacionFull.data,
                              tipo: tipoColocacionFull.label,
                              direccion: datosGps?.direccion || "",
                              nivelbateria: datosGps?.nivel_bateria || "",
                              ultimo_reporte: datosGps?.ultimo_reporte || "",
                              gps: gpsFull.data,
                              mov: movimientoFull,
                            });
                            setGpsAgregadosFull(gpsAgregadoTemp);
                            setGpsFull({ value: 0, label: "Seleccione un GPS", data: null });
                            setTipoColocacionFull({ value: 0, label: "Seleccione una opción", data_: null });
                          }}
                          pill
                          color="primary"
                          outline
                          disabled={
                            !gpsFull.value ||
                            !tipoColocacionFull.value
                          }
                        >
                          <i
                            class="fa fa-plus"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="agregar GPS"
                          ></i>
                        </Button>
                      </div>

                      <div className="col col-12 col-sm-12 col-md-12 ">
                        <Table
                          cards={true}
                          striped={true}
                          responsive={true}
                          className="table-vcenter"
                        >
                          <Table.Header align="center">
                            <Table.ColHeader> ID </Table.ColHeader>
                            <Table.ColHeader> NOMBRE GPS </Table.ColHeader>
                            <Table.ColHeader> TIPO GPS </Table.ColHeader>
                            <Table.ColHeader> DATOS GPS </Table.ColHeader>
                            <Table.ColHeader> NIVEL BATERIA GPS </Table.ColHeader>
                            <Table.ColHeader> ULTIMO REPORTE </Table.ColHeader>
                            {/* <Table.ColHeader> BORRAR </Table.ColHeader> */}
                          </Table.Header>
                          <Table.Body>
                            { gpsAgregadosFull.map((gpsDis, index) => (
                              <Table.Row align="center">
                                <Table.Col> {gpsDis.id} </Table.Col>
                                <Table.Col> {gpsDis.nombre} </Table.Col>
                                <Table.Col> {gpsDis.tipo} </Table.Col>
                                <Table.Col> {gpsDis.direccion} </Table.Col>
                                <Table.Col>
                                  {gpsDis.nivelbateria <= "100" &&
                                  gpsDis.nivelbateria >= "80" ? (
                                    <Icon prefix="fa" name="battery-4" />
                                  ) : null}
                                  {gpsDis.nivelbateria <= "79" &&
                                  gpsDis.nivelbateria >= "55" ? (
                                    <Icon prefix="fa" name="battery-3" />
                                  ) : null}
                                  {gpsDis.nivelbateria <= "54" &&
                                  gpsDis.nivelbateria >= "41" ? (
                                    <Icon prefix="fa" name="battery-2" />
                                  ) : null}
                                  {gpsDis.nivelbateria <= "40" &&
                                  gpsDis.nivelbateria >= "25" ? (
                                    <Icon prefix="fa" name="battery" />
                                  ) : null}
                                  {gpsDis.nivelbateria >= "0" &&
                                  gpsDis.nivelbateria <= "24" ? (
                                    <Icon prefix="fa" name="battery-0" />
                                  ) : null}
                                  {gpsDis.nivelbateria} %
                                </Table.Col>
                                <Table.Col> {gpsDis.ultimo_reporte} </Table.Col>
                                <Table.Col>
                                <div>
                                  <input
                                    type="file"
                                    className=""
                                    multiple
                                    onChange={(event) => {
                                      let imagesTemp= {...images};
                                      if(!imagesTemp[gpsDis.mov.id]){
                                        imagesTemp[gpsDis.mov.id]= {};
                                      }
                                      if(!imagesTemp[gpsDis.mov.id][gpsDis.id]){
                                        imagesTemp[gpsDis.mov.id][gpsDis.id]= [];
                                      }
                                      imagesTemp[gpsDis.mov.id][gpsDis.id]= [...event.target.files];
                                      //console.log(imagesTemp);
                                      setImages(imagesTemp);
                                    }}
                                  />
                                  <div>
                                    {images[gpsDis.mov.id]?.[gpsDis.id]?.map((image, index) => (
                                      <img key={index} src={URL.createObjectURL(image)} alt={image.name} width={"80px"}/>
                                    ))}
                                  </div>
                                </div>
                              </Table.Col>
                                <Table.Col>
                                  {/* <Button
                                    onClick={() =>{
                                      let gpsAgregadosFullTem= [...gpsAgregadosFull];
                                      gpsAgregadosFullTem.splice(index, 1);
                                      setGpsAgregadosFull(gpsAgregadosFullTem);
                                    }}
                                    color="danger"
                                  >
                                    Borrar
                                  </Button> */}
                                </Table.Col>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ) : null}
            </div>
          </div>
        </div>
        <div className="col-4 ml-6" style={{backgroundColor: "rgba(105, 151, 236, 0.08)"}}>
          <h3 className="float-right"> Vista previa </h3>
          <h5 className="float-left mt-6"> Movimiento 1 </h5>
          <ul className="list-group list-group-flush mt-8">
            <li className="list-group-item"><span className="float-left"></span>idMovimiento<span className="float-right">{movimientosPatios.idMovimiento}</span></li>
            <li className="list-group-item"><span className="float-left"></span>economicot<span className="float-right">{movimientosPatios.economicot}</span></li>
            <li className="list-group-item"><span className="float-left"></span>idRemolque<span className="float-right">{movimientosPatios.idRemolque? movimientosPatios.idRemolque.nombre: ""}</span></li>
            <li className="list-group-item"><span className="float-left"></span>operadorNombre<span className="float-right">
              {movimientosPatios.operadorNombre && movimientosPatios.operadorNombre.length?
                movimientosPatios.operadorNombre
              : <i className="fa fa-warning text-warning"></i>
              }</span></li>
            <li className="list-group-item"><span className="float-left"></span>operadorContacto<span className="float-right">
              { movimientosPatios.operadorContacto && movimientosPatios.operadorContacto.length?
                movimientosPatios.operadorContacto
                : <i className="fa fa-warning text-warning"></i>
              }</span></li>
            <li className="list-group-item"><span className="float-left"></span>operadorLicencia<span className="float-right">{movimientosPatios.operadorLicencia}</span></li>
            <li className="list-group-item"><span className="float-left"></span>tractorMarca<span className="float-right">
              {movimientosPatios.tractorMarca && movimientosPatios.tractorMarca.length?
                movimientosPatios.tractorMarca
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>tractorModelo<span className="float-right">
              {movimientosPatios.tractorModelo && movimientosPatios.tractorModelo.length?
                movimientosPatios.tractorModelo
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>tractorColor<span className="float-right">
              { movimientosPatios.tractorColor && movimientosPatios.tractorColor.length?
                movimientosPatios.tractorColor
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>tractorPlaca<span className="float-right">
              { movimientosPatios.tractorPlaca && movimientosPatios.tractorPlaca.length?
                movimientosPatios.tractorPlaca
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>idLocalidad<span className="float-right">{movimientosPatios.idLocalidad? movimientosPatios.idLocalidad.nombre:""}</span></li>
            <li className="list-group-item"><span className="float-left"></span>idUsuario<span className="float-right">
                {movimientosPatios.idUsuario? (movimientosPatios.idUsuario.nombre+" "+movimientosPatios.idUsuario.aPaterno+" "+movimientosPatios.idUsuario.aMaterno):""}
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>colocacionFecha<span className="float-right">{timeToDateFill(new Date().getTime())}</span></li>
            <li className="list-group-item"><span className="float-left"></span>enProtocolo<span className="float-right">
              { movimientosPatios.enProtocolo
                ? "Dentro de protocolo"
                : "Fuera de protocolo" }
            </span></li>
            {/*<li className="list-group-item"><span className="float-left"></span>movimientoLocal<span className="float-right">
              { movimientosPatios.movimientoLocal
                ? "Local"
                : "No Local" }
            </span></li>*/}
            <hr style={estilo} />
            <li className="list-group-item"><span className="float-left"></span>esFull<span className="float-right">{esFull? ("Full con: " + movimientosPatios.esFull): "Sencillo" }</span></li>
            <li className="list-group-item"><span className="float-left"></span>economicor<span className="float-right">
              {movimientosPatios.economicor && movimientosPatios.economicor.length?
                movimientosPatios.economicor
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>remolquePlaca<span className="float-right">
              {movimientosPatios.remolquePlaca && movimientosPatios.remolquePlaca.length?
                movimientosPatios.remolquePlaca
              : <i className="fa fa-warning text-warning"></i>
              }
              </span></li>
            <li className="list-group-item"><span className="float-left"></span>observaciones<span className="float-right">{movimientosPatios.observaciones}</span></li>
            <li className="list-group-item"><span className="float-left"></span>Gps's<span className="float-right">
              {gpsAgregado.map((ga, index)=> <span>{(index > 0 && index < gpsAgregado.length? ", ": "")+ ga.nombre}</span>) }
              </span></li>
            {gpsAgregadoOld.filter(gao => gpsAgregado.filter( ga=> ga.id === gao.id).length === 0 ).length?
              <li className="list-group-item text-danger"><span className="float-left"></span>Se removeran estos Gps's<span className="float-right">
                { gpsAgregadoOld.filter(gao => gpsAgregado.filter( ga=> ga.id === gao.id).length === 0 ).map((ga, index)=>
                  <span>{(index > 0 && index < gpsAgregadoOld.length? ", ": "")+ ga.nombre}</span>
                ) }
              </span></li>
            : null}
          </ul>
          <Box sx={{ width: '100%' }}>
            <Stepper activeStep={saveProgress.activeStep}>
              {steps.map((etiqueta, index) => {
                const labelProps = {};
                if (index === saveProgress.isStepFailed) {
                  labelProps.optional = (
                    <Typography variant="caption" color="error">
                      {saveProgress.stepFailedMessage}
                    </Typography>
                  );
                  labelProps.error = true;
                }

                return (
                  <Step key={etiqueta}>
                    <StepLabel {...labelProps}>{etiqueta}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
          { movimientosPatiosFull.idMovimiento && Number(movimientosPatiosFull.esFull) &&  movimientosPatios.esFull?
            <div>
              <hr style={estilo} />
              <h5 className="float-left mt-2"> Movimiento 2 </h5>
              <br/>
              <ul className="list-group list-group-flush mt-8">
                <li className="list-group-item"><span className="float-left"></span>idMovimiento<span className="float-right">{movimientosPatiosFull.idMovimiento}</span></li>
                <li className="list-group-item"><span className="float-left"></span>esFull<span className="float-right">{esFull? ("Full con: " + movimientosPatiosFull.esFull): "" }</span></li>
                <li className="list-group-item"><span className="float-left"></span>economicor<span className="float-right">
                  { movimientosPatiosFull.economicor && movimientosPatiosFull.economicor.length?
                      movimientosPatiosFull.economicor
                    : <i className="fa fa-warning text-warning"></i>
                    }
                  </span></li>
                <li className="list-group-item"><span className="float-left"></span>remolquePlaca<span className="float-right">
                  { movimientosPatiosFull.remolquePlaca && movimientosPatiosFull.remolquePlaca.length?
                    movimientosPatiosFull.remolquePlaca
                  : <i className="fa fa-warning text-warning"></i>
                  }
                  </span></li>
                <li className="list-group-item"><span className="float-left"></span>observaciones<span className="float-right">{movimientosPatiosFull.observaciones}</span></li>
                <li className="list-group-item"><span className="float-left"></span>Gps's<span className="float-right">
                  {gpsAgregadosFull.map((ga, index)=> <span>{(index > 0 && index < gpsAgregadosFull.length? ", ": "")+ ga.nombre}</span>) }
                </span></li>
                { gpsAgregadosFullOld.filter(gao => gpsAgregadosFull.filter( ga=> ga.id === gao.id).length === 0 ).length?
                  <li className="list-group-item text-danger"><span className="float-left"></span>Se removeran estos Gps's<span className="float-right">
                    { gpsAgregadosFullOld.filter(gao => gpsAgregadosFull.filter( ga=> ga.id === gao.id).length === 0 ).map((ga, index)=>
                      <span>{(index > 0 && index < gpsAgregadosFullOld.length? ", ": "")+ ga.nombre}</span>
                    ) }
                  </span></li>
                : null}
              </ul>
              <Box sx={{ width: '100%' }}>
                <Stepper activeStep={saveProgressFull.activeStep}>
                  {steps.map((etiqueta, index) => {
                    const labelProps = {};
                    if (index === saveProgressFull.isStepFailed) {
                      labelProps.optional = (
                        <Typography variant="caption" color="error">
                          {saveProgressFull.stepFailedMessage}
                        </Typography>
                      );
                      labelProps.error = true;
                    }

                    return (
                      <Step key={etiqueta}>
                        <StepLabel {...labelProps}>{etiqueta}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Box>
            </div>
            : null
          }
        </div>
      </div>
      <br />
        <div className="row">
          <div class="col-12">
            <Form.Group>
              <Button.List align="right">
                <Button
                  onClick={() => {
                    agregarGPS();
                  }}
                  color="primary"
                  disabled={
                    disabledButon ||
                    (
                      [160, 126, 100, 102, 325, 10, 101, 327, 227, 326, 391, 424,].includes(plataformaid)
                        ? !(
                            movimientosPatios.remolquePlaca.length &&
                            movimientosPatios.economicor.length &&
                            //gpsAgregado.length &&
                            (esFull ? (movimientoSecundario.value || Number(movimientosPatios.esFull)) : true)
                          )
                        : !(
                            idRemolque.value &&
                            controlador.value &&
                            //gpsAgregado.length &&
                            (esFull ? (movimientoSecundario.value || Number(movimientosPatios.esFull)) : true)
                          )
                    )
                  }
                >
                  Guardar
                </Button>
              </Button.List>
            </Form.Group>
          </div>
        </div>
    </div>
  );
  /*
  changeDentroDeProtocolo = (event) => {
    setState({ dentroDeProtocolo: event.target.checked });
  };*/
}
export default DatosMovimientoGpsForm;
